import React from "react";
import { useState, useEffect } from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import TextField from "@mui/material/TextField";
import TextareaAutosize from "@mui/material/TextareaAutosize";

import Select from "@mui/material/Select";


import { Dropdown } from 'semantic-ui-react'

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";

import DotLoader from "react-spinners/DotLoader";
import axios from "axios";
import Details from "../../../Images/details.png";
import Sign from "../../../Images/sign.png";
import Payment from "../../../Images/payment.png";
import war from "../../../Images/war.png";
import Notifications, { notify } from "react-notify-toast";
import gur from "../../../Images/imgp4.png";

import { BiTrashAlt } from "react-icons/bi";
import sts1 from "../../../Images/imgp1.png";
import nhc from "../../../Images/imgp2.png";
import psd from "../../../Images/imgp3.png";
import sign2 from "../../../Images/sign2.png";
import sign3 from "../../../Images/sign3.jpeg";

import logo from "../../../Images/logo.jpeg";

export default function Editcomp() {
  const [inputFields, setInputFields] = useState([]);
  const [height, setHeight] = React.useState(0);
  const [width, setWidth] = React.useState(0);
  
  const [height2, setHeight2] = React.useState(0);
  const [width2, setWidth2] = React.useState(0);

  const [name, setname] = React.useState("null");



  const [pdfname, setpdfname] = React.useState("");
  const [rate, setrate] = React.useState(0);
  const [desc, setdesc] = React.useState("null");

  const [foyertable, setfoyertable] = useState([]);
  const [livingtable, setlivingtable] = useState([]);
  const [diningtable, setdiningtable] = useState([]);
  const [bedroomtable, setbedroomtable] = useState([]);
  const [showerroomtable, setshowerroomtable] = useState([]);
  const [kicthentable, setkicthentable] = useState([]);

  const [temptable, settemptable] = useState([]);
  const [othertable, setothertable] = useState([]);
  
  const [loader, setloader] = useState(false);

  
  const [sitenmval, setsitenmval] = useState();
  
  const [savedid, fetchsavedid] = useState([]);
  
  const [saveinvoicename, setsaveinvoicename] = useState("");
  const [dtxt, setdtxt] = React.useState(
    "FOR IMMEDIATE BOOKING Rs 558000 ONLY (PREMIUM FINISH) HIGH GLOSSY FINISH FREE, GST AND ELICA CHIMNEY FREE "
  );
  //
  //
  //
  //  1.
  // 2.
  const [termstable, settermstable] = useState([
    {
      description:
        "10% FOR ORDER CONFIRMATION AND FOR START 2D, 3D DESIGNING WORK\n\n40% FOR START FACTORY PRODUCTION \n\n20% FOR START CARCASS ASSEMBLING STAGE  \n\n20% FOR FACTORY DOOR WORK STARED STAGE  \n\n10% AFTER WORK COMPLETED WHILE KEY HAND OVER",
    },
    {
      description: "THE PPRICE IS INCLUSIVE FOR THE TRANSPORTATION CHARGES",
    },
    {
      description:
        "STORAGE, POWER, AND WATER SHOULD BE PROVIDED BY THE CLIENT AT FREE OF COST.",
    },
    {
      description: "THIS QUOTE IS VALID FOR 15 DAYS.",
    },
    {
      description:
        "THE PRICE QUOTED IS EXCLUSIVE OF KITCHEN ACCESSORIES, GRANITE, SINK, WALL PAINTING, STONE GLADDING, ELECTRICAL, PLUMBING, CUSHION, CHIMNEY, CIVIL,CHIMNEY FIXING, PROFILE HANDLE, SLIDE DOOR FITTINGS,ETC.",
    },
    {
      description:
        " FOR LAMINATE GLOSSY FINISH EXTRA DIFFERENT AMOUNT PER SQ.FT RS: 150      ",
    },
    {
      description:
        "FOR ACRYLIC FINISH EXTRA DIFFERENT AMOUNT PER SQ.FT RS: 350 ",
    },
    {
      description:
        "FOR LACQUARED GLASS , VENNER OR DECCO FINISH EXTRA DIFFERENT AMOUNT PER SQFEET RS: 750",
    },
    {
      description:
        "FOR LACQUARED GLASS, ARISTO TYPE SLIDING DOOR EXTRA DIFFERENT AMOUNT PER SQFEET RS: 1100.",
    },
    {
      description:
        "FOR WOOD WORK ELECTRIALS, PROFILE HANDLE, CNC CUTTING, GRANET ETC EXTRA AMOUNT",
    },
    { description: "BEFORE HANDING OFF THE KEY, A FINAL MEASUREMENT WILL BE TAKEN.", },
  ]);
  const [spectable, setspectable] = useState([
    {
      item: "KITCHEN AND SERVICER AREA",
      description:
        "18MM MARINE BOILING WATER PROOF ISI 710 GRADE (KIT PLY) ORIGINAL LOGO SCANNER",
    },
    {
      item: "BED ROOMS AND LIVING AREA",
      description:
        "18MM BOILING WATER RESISTANCE ISI 303 GRADE (KIT PLY) ORIGINAL LOGO SCANNER",
    },
    {
      item: "OUTER LAMINATE",
      description: "IMM WATER PROOF (MERINO, GREEN LAM, VIRGO, BLOOM ETC)",
    },
    {
      item: "BACKER LAMINATE",
      description: "0.8MM WATER PROOF MERINO, GREEN LAM, VIRGO)",
    },
    {
      item: "SHUTTER HINGES",
      description: "EBCO SOFT CLOSER",
    },
    {
      item: "DRAWER CHANNELS",
      description: "TELESCOPIC NORMAL",
    },
    {
      item: "GLASS AND MIRROR",
      description: "SAINT GOBIAN (6MM WITH WITHE EDGING)",
    },
    {
      item: "SCREWS",
      description: "PATTA",
    },
    {
      item: "LOCKS",
      description: "EUROPA (WARDROBE DOOR ONLY PROVIDED",
    },
    {
      item: "ADHESIVE",
      description: "FEVICOL (OR) 3M SH GRADE",
    },
    {
      item: "EDGE BANDING",
      description: "2MM REHAU FOUR SIDE FOR SHUTTERS",
    },
    {
      item: "ACRYLIC",
      description: "EURO PRATIK (OR) GLO",
    },
    {
      item: "VENEER AND SOLID WOOD",
      description: "CENTURY (OR) EURO",
    },
    {
      item: "FALSE CEILING",
      description: "SAINT GOBIAN (GYPROC)",
    },
    {
      item: "WALL PAINTING",
      description: "ASIAN PAINTS PLASTIC EMULSION",
    },
    {
      item: "ELECTRICALS",
      description: "ORBIT OR SIMILAR",
    },
    {
      item: "KITCHEN CHIMENY AND HOB",
      description: "ELICA (LIFE TIME WARRANTY)",
    },
  ]);

  const [foyertotal, setfoyertotal] = useState(0);
  const [livingtotal, setlivingtotal] = useState(0);
  const [diningtotal, setdiningtotal] = useState(0);
  const [bedroomtotal, setbedroomtotal] = useState(0);
  const [showerroomtotal, setshowerroomtotal] = useState(0);
  const [kicthentotal, setkicthentotal] = useState(0);

  const [sno, setsno] = useState(0);
  const [othertotal, setothertotal] = useState(0);
  // "\n\n\n" :
  const [fname, setfname] = React.useState("LATO DESIGNZ");
  const [fphone, setfphone] = React.useState("7305603771");
  const [faddress, setfaddress] = React.useState(
    "Anna Nagar, chennai-600101"
  );
  const [fmail, setfmail] = React.useState("hello@latodesignz.com");

  const [item, setitem] = React.useState("");
  const [itemdesc, setitemdesc] = React.useState("");
  const [tname, settname] = React.useState("");
  const [tphone, settphone] = React.useState("");
  const [taddress, settaddress] = React.useState("");
  const [tmail, settmail] = React.useState("");

  const [tnc, settnc] = React.useState("null");

  const [gstper, setgstper] = React.useState("FREE");

  const addFields = (nm) => {
    let newfield = {
      description: "test2",
      height: 50,
      width: 60,
      totalsq: "test2",
      persq: "test2",
      total: "test2",
    };
    console.log(inputFields);

    setInputFields([...inputFields, newfield]);
  };
  const removeFields = (index) => {
    let data = [...inputFields];
    data.splice(index, 1);
    setInputFields(data);
  };
  const removefoyerFields = (index, rate) => {
    let data = [...foyertable];
    data.splice(index, 1);
    setfoyertable(data);
    console.log(typeof rate);
    var a = parseInt(rate, 0);
    var b = parseInt(foyertotal, 0);
    console.log(b + a);
    console.log(typeof foyertotal);

    console.log(foyertotal + rate);
  };
  const removelivingFields = (index, rate) => {
    let data = [...livingtable];
    data.splice(index, 1);
    setlivingtable(data);
  };
  const removediningFields = (index, rate) => {
    let data = [...diningtable];
    data.splice(index, 1);
    setdiningtable(data);
  };
  const removebedroomFields = (index, rate) => {
    let data = [...bedroomtable];
    data.splice(index, 1);
    setbedroomtable(data);
  };
  const removeshowerroomFields = (index, rate) => {
    let data = [...showerroomtable];
    data.splice(index, 1);
    setshowerroomtable(data);
  };
  const removekicthenFields = (index, rate) => {
    let data = [...kicthentable];
    data.splice(index, 1);
    setkicthentable(data);
  };
  const [foyer, fetchfoyer] = useState([]);

  const [living, fetchliving] = useState([]);
  const [dining, fetchdining] = useState([]);
  const [bedroom, fetchbedroom] = useState([]);
  const [showerroom, fetchshowerroom] = useState([]);
  const [other, fetchother] = useState([]);

  const [decription, fetchdescription] = useState({});

  const stateOptions = savedid.reverse().map((item, i) => ({
    key:i ,
    text:item.invoiceid ,
    value: item.invoiceid,
  }))

  const savepdf = () => {
   

    if(saveinvoicename != "" ){
      if(JSON.stringify(savedid).includes(saveinvoicename) == false){
        for (let i = 0; i < foyertable.length; i++) {
          
          foyertable[i].invoiceid = saveinvoicename;
          foyertable[i].snumber = i +1 ;
         
        }
        for (let i = 0; i < livingtable.length; i++) {
          livingtable[i].invoiceid = saveinvoicename;
          livingtable[i].snumber = i +1 ;

        }
        for (let i = 0; i < diningtable.length; i++) {
          diningtable[i].invoiceid = saveinvoicename;
          diningtable[i].snumber = i +1 ;

        }
        for (let i = 0; i < showerroomtable.length; i++) {
          showerroomtable[i].invoiceid = saveinvoicename;
          showerroomtable[i].snumber = i +1 ;

        }
        for (let i = 0; i < kicthentable.length; i++) {
          kicthentable[i].invoiceid = saveinvoicename;
          kicthentable[i].snumber = i +1 ;

        }
        for (let i = 0; i < bedroomtable.length; i++) {
          bedroomtable[i].invoiceid = saveinvoicename;
          bedroomtable[i].snumber = i +1 ;

        }
        for (let i = 0; i < othertable.length; i++) {
          othertable[i].invoiceid = saveinvoicename;
          othertable[i].snumber = i +1 ;

        }
    
    if(tname != ""){
      setloader(true);
const tojson = {
  invoiceid: saveinvoicename,
}
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(tojson),
      };
      fetch("https://api.dremerz.net/api/latosavedinvoiceid/", requestOptions)
        .then((response) => response.json())
        .then(console.log("done...name"));
    

    if(foyertable.length > 0){
      for(let i = 0; i < foyertable.length; i++){
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(foyertable[i]),
    };
    fetch("https://api.dremerz.net/api/latosavedinvoice/", requestOptions)
      .then((response) => response.json())
      .then(console.log("done..."));
  }
  }
  // 
  if(livingtable.length > 0){
    for(let i = 0; i < livingtable.length; i++){
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(livingtable[i]),
  };
  fetch("https://api.dremerz.net/api/latosavedinvoice/", requestOptions)
    .then((response) => response.json())
    .then(console.log("done..."));
}
// 

  }
  if(diningtable.length > 0){
    for(let i = 0; i < diningtable.length; i++){
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(diningtable[i]),
  };
  fetch("https://api.dremerz.net/api/latosavedinvoice/", requestOptions)
    .then((response) => response.json())
    .then(console.log("done..."));
  }
  
  }
  // 
  if(showerroomtable.length > 0){
    for(let i = 0; i < showerroomtable.length; i++){
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(showerroomtable[i]),
  };
  fetch("https://api.dremerz.net/api/latosavedinvoice/", requestOptions)
    .then((response) => response.json())
    .then(console.log("done..."));
  }
  
  }
  // 
  if(bedroomtable.length > 0){
    for(let i = 0; i < bedroomtable.length; i++){
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(bedroomtable[i]),
  };
  fetch("https://api.dremerz.net/api/latosavedinvoice/", requestOptions)
    .then((response) => response.json())
    .then(console.log("done..."));
  }
  
  }
  // 
  if(kicthentable.length > 0){
    for(let i = 0; i < kicthentable.length; i++){
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(kicthentable[i]),
  };
  fetch("https://api.dremerz.net/api/latosavedinvoice/", requestOptions)
    .then((response) => response.json())
    .then(console.log("done..."));
  }
  
  }
  // 
  if(othertable.length > 0){
    for(let i = 0; i < othertable.length; i++){
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(othertable[i]),
  };
  fetch("https://api.dremerz.net/api/latosavedinvoice/", requestOptions)
    .then((response) => response.json())
    .then(console.log("done..."));
  }
  
  }
  const totaldataamount = {
    invoiceid: saveinvoicename,
    foyertotal: foyertotal,
    livingtotal: livingtotal,
    diningtotal: diningtotal,
    showerroomtotal: showerroomtotal,
    bedroomtotal: bedroomtotal,
    kicthentotal: kicthentotal,
    othertotal: othertotal,
  };
  const requestOptionss = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(totaldataamount),
  };
  fetch(
    "https://api.dremerz.net/api/latototalamountdata/",
    requestOptionss
  )
    .then((response) => response.json())
    .then(console.log("done...data"));
  
  setloader(false);
  getsavedid();
alert("Data Saved...!")
    }else{
      alert("Enter To Address to Save...!");
    }
  }
  else{
    alert("Name Already Exists... Enter Some other Name");
  }
  }
  else{
    alert("Enter Saving Name");
  }


  };

  //
  const exportPDF = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);

    const title = "Calculated data";
    const headers = [["Room Name", "Price", "Gst", "Total"]];
    const headers2 = [
      ["", "", "SPECIFICATION", ""],
      ["Sno", "Item", "Description"],
    ];
    const headers3 = [["Sno", "Description"]];

    const foyerheaders = [
      ["FOYER-DETAILS", "Width", "Height", "Totalsq", "Persq", "Total"],
    ];
    const livingheaders = [
      ["LIVING-DETAILS", "Width", "Height", "Totalsq", "Persq", "Total"],
    ];
    const diningheaders = [
      ["DINING-DETAILS", "Width", "Height", "Totalsq", "Persq", "Total"],
    ];
    const showerroomheaders = [
      [
        "MASTER BEDROOM-DETAILS",
        "Width",
        "Height",
        "Totalsq",
        "Persq",
        "Total",
      ],
    ];
    const bedroomheaders = [
      ["BEDROOM-DETAILS", "Width", "Height", "Totalsq", "Persq", "Total"],
    ];
    const kicthenheaders = [
      ["KICTHEN-DETAILS", "Width", "Height", "Totalsq", "Persq", "Total"],
    ];
    const otherheaders = [
      ["KIDS BEDROOM-DETAILS", "Width", "Height", "Totalsq", "Persq", "Total"],
    ];
    const grandtotbody = [
      [
        "TOTAL",
        foyertotal +
          livingtotal +
          diningtotal +
          showerroomtotal +
          bedroomtotal +
          kicthentotal +
          othertotal,
      ],
      ["GST", gstper],
      [
        "GRAND TOTAL",
        gstper != "FREE"
          ? ((foyertotal +
              livingtotal +
              diningtotal +
              showerroomtotal +
              bedroomtotal +
              kicthentotal +
              othertotal) *
              gstper) /
              100 +
            foyertotal +
            livingtotal +
            diningtotal +
            showerroomtotal +
            bedroomtotal +
            kicthentotal +
            othertotal
          : foyertotal +
            livingtotal +
            diningtotal +
            showerroomtotal +
            bedroomtotal +
            kicthentotal +
            othertotal,
      ],
      [dtxt],
    ];

    const totaldata = [
      ["Foyer", foyertotal, gstper, foyertotal],
      ["Living", livingtotal, gstper, livingtotal],
      ["Dining", diningtotal, gstper, diningtotal],
      ["Master-bedroom", showerroomtotal, gstper, showerroomtotal],
      ["Kids-bedroom", othertotal, gstper, othertotal],
      ["Bedroom", bedroomtotal, gstper, bedroomtotal],
      ["Kicthen", kicthentotal, gstper, kicthentotal],

      [
        "Total Amount",
        "",
        "",
        gstper != "FREE"
          ? ((foyertotal +
              livingtotal +
              diningtotal +
              showerroomtotal +
              bedroomtotal +
              kicthentotal +
              othertotal) *
              gstper) /
              100 +
            foyertotal +
            livingtotal +
            diningtotal +
            showerroomtotal +
            bedroomtotal +
            kicthentotal +
            othertotal
          : foyertotal +
            livingtotal +
            diningtotal +
            showerroomtotal +
            bedroomtotal +
            kicthentotal +
            othertotal,
      ],
    ];
    const data2 = [["--", "--", "--", "--", "--", "--", "--"]];
    var toadress = tname + "\n" + tphone + "\n" + tmail + "\n" + taddress;
    var fromadress = fname + "\n" + fphone + "\n" + fmail + "\n" + faddress;

    const specdatatab = spectable?.map((item, i) => [
      i + 1,
      item.item,
      item.description,
    ]);
    const termsdatatab = termstable?.map((item, i) => [i + 1, item.description]);

    const foyerdatatab = foyertable?.map((item, i) => [
      item.name.includes("*")
        ? "\n\t\t" + item.name + "\n" + item.description
        : "\t\t" + item.name + " \n\n" + item.description + " \n",
      " \n\n" + item.width,
      " \n\n" + item.height,

      " \n\n" + item.totalsq,
      " \n\n" + item.persq,
      " \n\n" + item.total,
    ]);

    const livingdatatab = livingtable?.map((item, i) => [
      item.name.includes("*")
        ? "\n\t\t" + item.name + "\n" + item.description
        : "\t\t" + item.name + " \n\n" + item.description + " \n",
      " \n\n" + item.width,
      " \n\n" + item.height,

      " \n\n" + item.totalsq,
      " \n\n" + item.persq,
      " \n\n" + item.total,
    ]);
    const diningdatatab = diningtable?.map((item, i) => [
      item.name.includes("*")
        ? "\n\t\t" + item.name + "\n" + item.description
        : "\t\t" + item.name + " \n\n" + item.description + " \n",
      " \n\n" + item.width,
      " \n\n" + item.height,

      " \n\n" + item.totalsq,
      " \n\n" + item.persq,
      " \n\n" + item.total,
    ]);
    const showerroomdatatab = showerroomtable?.map((item, i) => [
      item.name.includes("*")
        ? "\n\t\t" + item.name + "\n" + item.description
        : "\t\t" + item.name + " \n\n" + item.description + " \n",
      " \n\n" + item.width,
      " \n\n" + item.height,

      " \n\n" + item.totalsq,
      " \n\n" + item.persq,
      " \n\n" + item.total,
    ]);
    const bedroomdatatab = bedroomtable?.map((item, i) => [
      item.name.includes("*")
        ? "\n\t\t" + item.name + "\n" + item.description
        : "\t\t" + item.name + " \n\n" + item.description + " \n",
      " \n\n" + item.width,
      " \n\n" + item.height,

      " \n\n" + item.totalsq,
      " \n\n" + item.persq,
      " \n\n" + item.total,
    ]);
    const kicthendatatab = kicthentable?.map((item, i) => [
      item.name.includes("*")
        ? "\n\t\t" + item.name + "\n" + item.description
        : "\t\t" + item.name + " \n\n" + item.description + " \n",
      " \n\n" + item.width,
      " \n\n" + item.height,

      " \n\n" + item.totalsq,
      " \n\n" + item.persq,
      " \n\n" + item.total,
    ]);

    const otherdatatab = othertable?.map((item, i) => [
      item.name.includes("*")
        ? "\n\t\t" + item.name + "\n" + item.description
        : "\t\t" + item.name + " \n\n" + item.description + " \n",
      " \n\n" + item.width,
      " \n\n" + item.height,

      " \n\n" + item.totalsq,
      " \n\n" + item.persq,
      " \n\n" + item.total,
    ]);

    let totalcontent = {
      headStyles: { fillColor: "#0c4351" , background: "#0c4351",
        textColor: "white",},
      startY: 80,
      head: headers,
      styles: {
        fontSize: 11,
      },
      body: totaldata,
    };
    let speccontent = {
      headStyles: { fillColor: "#0c4351" , background: "#0c4351",
        textColor: "white",},
      startY: 310,
      head: headers2,
      body: specdatatab,
      styles: {
        fontSize: 8,
      },
    };
    let termscontent = {
      headStyles: { fillColor: "#0c4351" , background: "#0c4351",
        textColor: "white",},
      styles: {
        fontSize: 8,
      },
      head: headers3,
      body: termsdatatab,
    };
    let foyercontent = {
      startY: 250,
      // columnStyles: { 0: { halign: 'center', fillColor: [0, 255, 0] } },
      styles: {
        align: "center",
       
      },
      headStyles: { fillColor: "#0c4351" , background: "#0c4351",
        textColor: "white",},
      head: foyerheaders,

      body: foyertable.length == 0 ? data2 : foyerdatatab,
    };
    let livingcontent = {
      headStyles: { fillColor: "#0c4351" , background: "#0c4351",
        textColor: "white",},

      startY: foyertable.length == 0 ? 250 : null,
      head: livingheaders,
      body: livingtable.length == 0 ? data2 : livingdatatab,
    };

    // let diningsty =

    let diningcontent = {
      headStyles: { fillColor: "#0c4351" , background: "#0c4351",
        textColor: "white",},

      startY: foyertable.length == 0 && livingtable.length == 0 ? 250 : null,
      head: diningheaders,
      body: diningtable.length == 0 ? data2 : diningdatatab,
    };

    let showerroomcontent = {
      headStyles: { fillColor: "#0c4351" , background: "#0c4351",
        textColor: "white",},

      startY:
        foyertable.length == 0 &&
        livingtable.length == 0 &&
        diningtable.length == 0
          ? 250
          : null,
      head: showerroomheaders,
      body: showerroomtable.length == 0 ? data2 : showerroomdatatab,
    };
    let bedroomcontent = {
      headStyles: { fillColor: "#0c4351" , background: "#0c4351",
        textColor: "white",},
      styles: {
        align: "center",
      },
      startY:
        foyertable.length == 0 &&
        livingtable.length == 0 &&
        diningtable.length == 0 &&
        showerroomtable.length == 0
          ? 250
          : null,
      head: bedroomheaders,
      body: bedroomtable.length == 0 ? data2 : bedroomdatatab,
    };
    let othercontent = {
      headStyles: { fillColor: "#0c4351" , background: "#0c4351",
        textColor: "white",},
      startY:
        foyertable.length == 0 &&
        livingtable.length == 0 &&
        diningtable.length == 0 &&
        showerroomtable.length == 0 &&
        bedroomtable.length == 0 &&
        foyertable.length == 0
          ? 250
          : null,
      head: otherheaders,
      body: othertable.length == 0 ? data2 : otherdatatab,
    };
    let kicthencontent = {
      headStyles: { fillColor: "#0c4351" , background: "#0c4351",
        textColor: "white",},

      startY:
        foyertable.length == 0 &&
        livingtable.length == 0 &&
        diningtable.length == 0 &&
        showerroomtable.length == 0 &&
        bedroomtable.length == 0 &&
        othertable.length == 0
          ? 250
          : null,
      head: kicthenheaders,
      body: kicthentable.length == 0 ? data2 : kicthendatatab,
    };
    let grandtotcontent = {
      headStyles: { fillColor: "#0c4351" , background: "#0c4351",
        textColor: "white",},
      didParseCell: function (data) {
        if (data.row.index === 3) {
          data.cell.styles.fontStyle = "bold";
        }
        if (data.row.index === 3) {
          data.cell.styles.fontSize = 12;
        }
      },
      startY:
        foyertable.length == 0 &&
        livingtable.length == 0 &&
        diningtable.length == 0 &&
        showerroomtable.length == 0 &&
        bedroomtable.length == 0 &&
        foyertable.length == 0 &&
        kicthentable.length == 0 &&
        othertable.length == 0
          ? 250
          : null,
      // head: otherheaders,
      body: grandtotbody,
    };

    let totc =
      foyertotal +
      livingtotal +
      diningtotal +
      showerroomtotal +
      bedroomtotal +
      kicthentotal;
    var termnc =
      tnc == "null"
        ? "1. 10% FOR ORDER CONFIRMATION AND FOR START 2D, 3D DESIGNING WORK\n2.40% FOR START FACTORY PRODUCTION\n3.40% FOR START CARCASS ASSEMBLING AND DOOR WORK\n4. 10% AFTER WORK 10% AFTER WORK COMPLETED\n 5.WHILE KEY HAND OVER THE PPRICE IS INCLUSIVE FOR THE TRANSPORTATION CHARGES.\nSTORAGE, POWER, AND WATER SHOULD BE PROVIDED BY THE CLIENT AT FREE OF COST.\nTHIS QUOTE IS VALID FOR 15 DAYS.\nTHE PRICE QUOTED IS EXCLUSIVE OF KITCHEN ACCESSORIES, GRANITE, SINK,\nWALL PAINTING, STONE GLADDING, \nFALSECEILING WOOD WORK, PROFILE HANDLES, ELECTRICAL, \nPLUMBING, CUSHION, CHIMNEY, \nCIVIL, CNC CUTTING, CHIMNEY FIXING ETC.\n ADVANCE PAYMENT NON REFUNDABLE.\n\n1. FOR LAMINATE GLOSSY FINISH EXTRA DIFFERENT AMOUNT PER SQ.FT RS: 150\n2. FOR ACRYLIC FINISH EXTRA DIFFERENT AMOUNT PER SQ.FT RS: 350\n3. FOR LACQUARED, VENNER OR DECCO FINISH EXTRA DIFFERENT AMOUNT PER SOFEET RS: 750\n4. FOR WOOD WORK ELECTRIALS, PROFILE, CNC CUTTING, GRANET ETC EXTRA AMOUNT \n BEFORE HANDING OFF THE KEY, A FINAL MEASUREMENT WILL BE TAKEN."
        : tnc;

    doc.text("PROFORMA  # INVOICE ", marginLeft, 40);
    doc.setTextColor(100);
    doc.setFontSize(10);
    doc.addImage(logo, "PNG", 340, 30, 100, 100);
    doc.text("To \n" + toadress, marginLeft, 60);
    doc.text("From\n\n" + fromadress, 350, 145);
    // doc.text(
    //   "Website : trendingdecors.in",
    //   50,
    //   185
    // );
    // doc.text(
    //   "Phone : +91 9600114394, +91 9345172854 ",
    //   50,
    //   197
    // );
    doc.text(
      "",
      marginLeft,
      165
    );

    doc.text(
      "Managing Director : Mr Sathish K\nPhone : +91 7845832771",
      190,
      165
    );

    doc.setTextColor(100);
    doc.setFontSize(10);
    {
      foyertable.length == 0 ? <> </> : autoTable(doc,foyercontent);
    }
    // doc.addPage();
    // doc.text("LIVING-DETAILS", 40, 100);
    doc.setTextColor(100);
    doc.setFontSize(10);
    {
      livingtable.length == 0 ? <></> : autoTable(doc,livingcontent);
    }
    // doc.addPage();
    // doc.text("DINING-DETAILS", 40, 100);
    doc.setTextColor(100);
    doc.setFontSize(10);
    {
      diningtable.length == 0 ? <></> : autoTable(doc,diningcontent);
    }
    // doc.addPage();
    // doc.text("SHOWERROOM-DETAILS", 40, 100);
    doc.setTextColor(100);
    doc.setFontSize(10);
    {
      showerroomtable.length == 0 ? <></> : autoTable(doc,showerroomcontent);
    }
    // doc.addPage();
    // doc.text("BEDROOM-DETAILS", 40, 100);
    doc.setTextColor(100);
    doc.setFontSize(10);
    {
      bedroomtable.length == 0 ? <></> : autoTable(doc,bedroomcontent);
    }
    // doc.addPage();
    // doc.text("KICTHEN-DETAILS", 40, 100);

    {
      othertable.length == 0 ? <></> : autoTable(doc,othercontent);
    }
    doc.setTextColor(100);
    doc.setFontSize(10);
    {
      kicthentable.length == 0 ? <></> : autoTable(doc,kicthencontent);
    }
    autoTable(doc,grandtotcontent);

    doc.addPage();
    doc.text("Total Calculation ", marginLeft, 40);
    autoTable(doc,totalcontent);
    autoTable(doc,speccontent);

    // doc.setFontSize(32);
    // doc.text("TOTAL AMOUNT : " + totc, marginLeft, 300);
    // doc.setTextColor(000);

    doc.addPage();

    doc.text("TERMS & CONDITIONS : ", marginLeft, 35);
    doc.setFontSize(5);
    autoTable(doc,termscontent);
    // doc.text(termnc, 50, 50);
   // doc.addImage(Payment, "PNG", 120, 480, 380, 170);
    // doc.addImage(Details, "PNG", 165, 370, 300, 120);
    // doc.addImage(war, "PNG", 70, 370, 90, 90);
    doc.addImage(nhc, "PNG", 300, 370, 80, 80);
    doc.addImage(psd, "PNG", 200, 370, 80, 80);
    doc.addImage(sts1, "PNG", 400, 370, 80, 80);
    doc.addImage(gur, "PNG", 100, 370, 80, 80);

    doc.addImage(sign3, "PNG", 50, 680, 120, 100);
    doc.addImage(sign2, "PNG", 370, 680, 200, 100);

    doc.save(pdfname == "" ? tname + taddress + ".pdf" : "pdfname" + ".pdf");
  };

  const [kicthen, fetchkicthen] = useState([]);
  const getfoyerData = () => {
    let url = "https://api.dremerz.net/api/latofoyer/";

    fetch(url)
      .then((res) => res.json())
      .then((res) => {
        fetchfoyer(res);
        console.warn(res);
      });
  };
  const getlivingData = () => {
    let url = "https://api.dremerz.net/api/latolivingdata/";

    fetch(url)
      .then((res) => res.json())
      .then((res) => {
        fetchliving(res);
        console.warn(res);
      });
  };
  const getdiningData = () => {
    let url = "https://api.dremerz.net/api/latodiningdata/";

    fetch(url)
      .then((res) => res.json())
      .then((res) => {
        fetchdining(res);
        console.warn(res);
      });
  };
  const getbedroomData = () => {
    let url = "https://api.dremerz.net/api/latobedroomdata/";

    fetch(url)
      .then((res) => res.json())
      .then((res) => {
        fetchbedroom(res);
        console.warn(res);
      });
  };
  const getshowerroomData = () => {
    let url = "https://api.dremerz.net/api/latoshowerroomdata/";

    fetch(url)
      .then((res) => res.json())
      .then((res) => {
        fetchshowerroom(res);
        console.warn(res);
      });
  };
  const getkicthenData = () => {
    let url = "https://api.dremerz.net/api/latokicthendata/";

    fetch(url)
      .then((res) => res.json())
      .then((res) => {
        fetchkicthen(res);
        console.warn(res);
      });
  };
  const getotherData = () => {
    let url = "https://api.dremerz.net/api/latootherdata/";

    fetch(url)
      .then((res) => res.json())
      .then((res) => {
        fetchother(res);
        console.error(res);
      });
  };
  const getsavedid = () => {
    let url = "https://api.dremerz.net/api/latosavedinvoiceid/";

    fetch(url)
      .then((res) => res.json())
      .then((res) => {
        fetchsavedid(res);
        console.error(res);
      });
  };

  useEffect(() => {
    getfoyerData();
    getlivingData();
    getdiningData();
    getbedroomData();
    getshowerroomData();
    getkicthenData();
    getotherData();
    
    getsavedid();
  }, []);
function GetSortOrder(prop) {    
    return function(a, b) {    
        if (a[prop] > b[prop]) {    
            return 1;    
        } else if (a[prop] < b[prop]) {    
            return -1;    
        }    
        return 0;    
    }    
}    
function sortByProperty(property){  
   return function(a,b){  
      if(a[property] > b[property])  
         return 1;  
      else if(a[property] < b[property])  
         return -1;  
  
      return 0;  
   }  
}
  
 const getBird = (event, {value}) => {
    console.log(value);
    let bird_name = event.target.textContent;
    console.log(bird_name);
    setsitenmval(bird_name)
}
  return (
   <>
   {loader ? <>
   <div  className="videoplyer">
   <DotLoader
        color={"#16213E"}
        loading={loader}
        // cssOverride={override}
        size={100}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
   </div>
   
   </> : 
   
   
   <>
    <div>
        <table className="ucaltab">
          <tr className="uctr">
            <td className="ucaltb2"> Site Name : </td>
            <td className="ucaltb2">
             <Dropdown  className="selectcomp" placeholder='Search..'  search selection options={stateOptions}
              onChange={getBird}
               />
            </td>
          </tr>
          <tr>
            <td > </td>
            <td >
                <br/>
                <Button
                 onClick={() => {
                    try {
                      setloader(true);
                        fetch( "https://api.dremerz.net/api/latosavedinvoice/?invoiceid="+sitenmval+"&tabname=foyer")
                          .then((res) => res.json())
                          .then((res) => {
                            res.sort((a, b) => a.snumber - b.snumber);
                            setfoyertable(res);
                            console.error(res);
                          });
                          
                         

                        //   
                        fetch( "https://api.dremerz.net/api/latosavedinvoice/?invoiceid="+sitenmval+"&tabname=living")
                        .then((res) => res.json())
                        .then((res) => {
                          res.sort((a, b) => a.snumber - b.snumber);
                          setlivingtable(res);
                          console.error(res);
                        });
                        // 
                        fetch( "https://api.dremerz.net/api/latosavedinvoice/?invoiceid="+sitenmval+"&tabname=dining")
                        .then((res) => res.json())
                        .then((res) => {
                          res.sort((a, b) => a.snumber - b.snumber);
                          setdiningtable(res);
                          console.error(res);
                        });
                        // 
                        fetch( "https://api.dremerz.net/api/latosavedinvoice/?invoiceid="+sitenmval+"&tabname=showerroom")
                        .then((res) => res.json())
                        .then((res) => {
                          res.sort((a, b) => a.snumber - b.snumber);
                          setshowerroomtable(res);
                          console.error(res);
                        });
                        // 
                        fetch( "https://api.dremerz.net/api/latosavedinvoice/?invoiceid="+sitenmval+"&tabname=bedroom")
                        .then((res) => res.json())
                        .then((res) => {
                          res.sort((a, b) => a.snumber - b.snumber);
                          setbedroomtable(res);
                          console.error(res);
                        });
                        // 
                        fetch( "https://api.dremerz.net/api/latosavedinvoice/?invoiceid="+sitenmval+"&tabname=kicthen")
                        .then((res) => {
                          res.sort((a, b) => a.snumber - b.snumber);
                          setkicthentable(res);
                          console.error(res);
                        });
                        // 
                        fetch( "https://api.dremerz.net/api/latosavedinvoice/?invoiceid="+sitenmval+"&tabname=other")
                        .then((res) => res.json())
                        .then((res) => {
                          res.sort((a, b) => a.snumber - b.snumber);
                          setothertable(res);
                          console.error(res);
                        });
// 
                        fetch( "https://api.dremerz.net/api/latototalamountdata/?invoiceid="+sitenmval)
                        .then((res) => res.json())
                        .then((res) => {
                          
                          // setothertable(res);
                          console.warn(res);
                          // foyertable.sort(GetSortOrder("id"));
                          
                          setfoyertotal(parseInt(res[0].foyertotal));
                          setlivingtotal(parseInt(res[0].livingtotal));
                          setkicthentotal(parseInt(res[0].kicthentotal));
                          setbedroomtotal(parseInt(res[0].bedroomtotal));
                          setshowerroomtotal(parseInt(res[0].showerroomtotal));
                          setothertotal(parseInt(res[0].othertotal));
                          setdiningtotal(parseInt(res[0].diningtotal));
                        });
                        setloader(false);
                    } catch {
                      alert("Error Occured");
                    }

                  

                   
                  }
                
                
                }

                //   
               
                
                
                >
                    Get Data
                </Button>
             
            </td>
          </tr>
        </table>
      </div>
      <div className="Upc1">
        <div className="Upc11">
          <div className="cal1">
          {tname == "" ? (
                  <>Please Enter To Name </>
                ) : (
            <Tabs
              defaultActiveKey="Foyer"
              transition={false}
              id="noanim-tab-example"
              className="mb-3 "
            >
             
              <Tab eventKey="Foyer" title="Foyer">
              
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                  
                  <Row>
                    <Col sm={3}>
                      <Nav variant="pills" className="flex-column">
                        {foyer.map((item, i) => (
                          <Nav.Item>
                            <Nav.Link eventKey={item.name}>
                              {item.name}
                            </Nav.Link>
                          </Nav.Item>
                        ))}
                        <Nav.Item>
                          <Nav.Link eventKey="add-new">ADD NEW</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="add-false">
                            ADD FALSE-CELING
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </Col>
                    <Col sm={9}>
                      <Tab.Content>
                        {foyer.map((item, i) => (
                          <Tab.Pane eventKey={item.name}>
                            <TextField
                              id="outlined-basic"
                              value={width}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth(e.target.value)}
                            /> &nbsp;&nbsp;
                            <TextField
                              id="outlined-basic"
                              value={width2}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth2(e.target.value)}
                            /><br/>
                            <br/>
                            <TextField
                              value={height}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight(e.target.value)}
                            />&nbsp;&nbsp;
                             <TextField
                              value={height2}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight2(e.target.value)}
                            />
                           
                            {" "}
                            <br />
                            <br />
                            <TextField
                              id="outlined-basic"
                              label="Name"
                              defaultValue={item.name}
                              variant="outlined"
                              onChange={(e) => setname(e.target.value)}
                            />
                            &nbsp;&nbsp;
                            <TextField
                              id="outlined-basic"
                              label="Rate"
                              defaultValue={item.rate}
                              variant="outlined"
                              onChange={(e) => setrate(e.target.value)}
                            />
                            <br />
                            <br />
                            <TextareaAutosize
                              aria-label="Description"
                              minRows={3}
                              className="textarea1"
                              defaultValue={item.desc}
                              onChange={(e) => setdesc(e.target.value)}
                              placeholder="Description"
                              style={{ width: 500 }}
                            />
                            <br />
                            <br />
                            <Button
                              onClick={() => {
                                var th = parseFloat(height) + parseFloat(height2);
                                var tw = parseFloat(width) + parseFloat(width2);
                               
                                var irate = rate == 0 ? item.rate : rate;
                                var totsq = th * tw;
                                var total =
                                  (Math.round(totsq * 10) / 10) * irate;
                                var descr = desc == "null" ? item.desc : desc;
                                var sname = name == "null" ? item.name : name;

                                var newfield = {
                                  
                                  
                                  description: descr,
                                  name: sname,
                                  invoiceid: tname,
                                  tabname: "foyer",
                                  height: th,
                                  width: tw,
                                  totalsq: Math.round(totsq * 10) / 10,
                                  persq: irate,
                                  total: Math.round(total * 10) / 10,
                                };
                                setfoyertable([...foyertable, newfield]);
                                setfoyertotal(foyertotal + total);
                                settemptable([newfield]);
                                setname("null");
                                setdesc("null");
                                setWidth(0);
                                setHeight(0);
                                setWidth2(0);
                                setHeight2(0);
                                setWidth2(0);
                                setHeight2(0);

                                setrate(0);
                                notify.show(
                                  "" + sname + " Added Sucessfully !",
                                  "success",
                                  2000
                                );
                              }}
                            >
                              Add
                            </Button>
                            &nbsp;
                            <Button
                              onClick={() => {
                                try {
                                  axios
                                    .delete(
                                      "https://api.dremerz.net/api/latofoyer/" +
                                        item.id +
                                        "/"
                                    )
                                    .then(() => {
                                      alert("Delete successful");
                                      getfoyerData();
                                    });
                                } catch {
                                  alert("Error Occured");
                                }
                              }}
                            >
                              Delete
                            </Button>
                            &nbsp;
                            <Button
                              color="error"
                              onClick={() => {
                                try {
                                  var th = parseFloat(height) + parseFloat(height2);
                                var tw = parseFloat(width) + parseFloat(width2);
                                  var irate = rate == 0 ? item.rate : rate;
                                  var totsq = height * width;
                                  var total =
                                    (Math.round(totsq * 10) / 10) * irate;
                                  var descr = desc == "null" ? item.desc : desc;
                                  var sname = name == "null" ? item.name : name;

                                  var newfield = {
                                    name: sname,
                                    desc: descr,
                                    rate: irate,
                                  };
                                  axios
                                    .put(
                                      "https://api.dremerz.net/api/latofoyer/" +
                                        item.id +
                                        "/",
                                      newfield
                                    )
                                    .then(() => {
                                      alert("Update Sucessful");
                                      getfoyerData();
                                      setname("null");
                              setdesc("null");
                              setWidth(0);
                              setHeight(0);
                              setWidth2(0);
                              setHeight2(0);
                              setrate(0);
                                      alert("Updated");
                                    });
                                } catch {
                                  alert("Error Occured");
                                }
                              }}
                            >
                              Update
                            </Button>
                          </Tab.Pane>
                        ))}
                        <Tab.Pane eventKey="add-new">
                        <TextField
                              id="outlined-basic"
                              value={width}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth(e.target.value)}
                            /> &nbsp;&nbsp;
                            <TextField
                              id="outlined-basic"
                              value={width2}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth2(e.target.value)}
                            /><br/>
                            <br/>
                            <TextField
                              value={height}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight(e.target.value)}
                            />&nbsp;&nbsp;
                             <TextField
                              value={height2}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight2(e.target.value)}
                            />
                         
                         {" "}
                          <br />
                          <br />
                          <TextField
                            id="outlined-basic"
                            label="Rate"
                            variant="outlined"
                            value={rate}
                            onChange={(e) => setrate(e.target.value)}
                          />
                          &nbsp;&nbsp;
                          <TextField
                            id="outlined-basic"
                            label="Name"
                            variant="outlined"
                            value={name}
                            onChange={(e) => setname(e.target.value)}
                          />
                          <br />
                          <br />
                          <TextareaAutosize
                            aria-label="Description"
                            minRows={3}
                            className="textarea1"
                            onChange={(e) => setdesc(e.target.value)}
                            placeholder="Description"
                            value={desc}
                            style={{ width: 500 }}
                          />
                          <br />
                          <br />
                          <Button
                            onClick={() => {
                              var th = parseFloat(height) + parseFloat(height2);
                              var tw = parseFloat(width) + parseFloat(width2);
                              var totsq = th * tw;
                              var total = (Math.round(totsq * 10) / 10) * rate;
                              var descr = desc;

                              var newfield = {
                                invoiceid: tname,
                                tabname: "foyer",
                                description: descr,
                                name: name,
                                height: th,
                                width: tw,
                                totalsq: Math.round(totsq * 10) / 10,
                                persq: rate,
                                total: Math.round(total * 10) / 10,
                              };
                              setfoyertable([...foyertable, newfield]);
                              setfoyertotal(foyertotal + total);
                              settemptable([newfield]);
                              setname("null");
                              setdesc("null");
                              setWidth(0);
                              setHeight(0);
                              setWidth2(0);
                              setHeight2(0);
                              setWidth2(0);
                              setHeight2(0);
                              setrate(0);

                              notify.show(
                                "" + name + " Added Sucessfully !",
                                "success",
                                2000
                              );
                            }}
                          >
                            Add
                          </Button>
                          &nbsp;&nbsp;
                          <Button
                            onClick={() => {
                              var totsq = height * width;
                              var total = (Math.round(totsq * 10) / 10) * rate;
                              var descr = desc;

                              var newfield = {
                                name: name,
                                desc: descr,
                                rate: rate,
                              };

                              try {
                                axios
                                  .post(
                                    "https://api.dremerz.net/api/latofoyer/",
                                    newfield
                                  )
                                  .then((response) => {
                                    console.log(response);
                                    alert("Sucessfully Submited");
                                    getfoyerData();
                                    setname("null");
                              setdesc("null");
                              setWidth(0);
                              setHeight(0);
                              setWidth2(0);
                              setHeight2(0);
                              setrate(0);
                                  })
                                  .catch((error) => {
                                    console.log(error);
                                    alert("Error Occured");
                                  });
                              } catch {
                                alert("Error Occured");
                              }
                            }}
                          >
                            Post
                          </Button>
                        </Tab.Pane>
                        {/*  */}
                        <Tab.Pane eventKey="add-false">
                          <TextField
                            id="outlined-basic"
                            label="Name"
                            variant="outlined"
                            onChange={(e) =>
                              setname("*\t" + e.target.value + "\t*")
                            }
                          />
                          <br />
                          <br />
                          <Button
                            onClick={() => {
                              var totsq = height * width;
                              var total = (Math.round(totsq * 10) / 10) * rate;
                              var descr = desc;
                              var sname = name == "null" ? item.name : name;

                              var newfield = {
                                invoiceid: tname,
                                tabname: "foyer",
                                description: "",
                                name: sname,
                                height: "",
                                width: "",
                                totalsq: "",
                                persq: "",
                                total: "",
                              };
                              setfoyertable([...foyertable, newfield]);
                              setname("null");
                              notify.show(
                                "" + sname + " Added Sucessfully !",
                                "success",
                                2000
                              );
                            }}
                          >
                            Add
                          </Button>
                          &nbsp;&nbsp;
                          <br/>
                          <br/>
                          <Button
                                  onClick={() => {
                                   

                                    var newfield = {
                                      description: "",
                                      invoiceid: tname,
                                      tabname: "foyer",
                                      name: "*\tSemi-False Ceiling\t*",
                                      height: "",
                                      width: "",
                                      totalsq: "",
                                      persq: "",
                                      total: "",
                                    };
                                    setfoyertable([
                                      ...foyertable,
                                      newfield,
                                    ]);
                                    setname("null");
                                    notify.show(
                                      "*\ Semi-False Ceiling\t* Added Sucessfully !",
                                      "success",
                                      2000
                                    );
                                  }}
                                >
                                 Semi-False ceiling
                                </Button>
                                &nbsp;
                                &nbsp;
                                <Button
                                  onClick={() => {
                                   

                                    var newfield = {
                                      description: "",
                                      invoiceid: tname,
                                      tabname: "foyer",
                                      name: "*\tFull-False Ceiling\t*",
                                      height: "",
                                      width: "",
                                      totalsq: "",
                                      persq: "",
                                      total: "",
                                    };
                                    setfoyertable([
                                      ...foyertable,
                                      newfield,
                                    ]);
                                    setname("null");
                                    notify.show(
                                      "*\ Full-False Ceiling\t* Added Sucessfully !",
                                      "success",
                                      2000
                                    );
                                  }}
                                >
                                 Full-False ceiling
                                </Button>
                        </Tab.Pane>
                        {/*  */}
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
              </Tab>
              <Tab eventKey="Living" title="Living">
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                  <Row>
                    <Col sm={3}>
                      <Nav variant="pills" className="flex-column">
                        {living.map((item, i) => (
                          <Nav.Item>
                            <Nav.Link eventKey={item.name}>
                              {item.name}
                            </Nav.Link>
                          </Nav.Item>
                        ))}
                        <Nav.Item>
                          <Nav.Link eventKey="add-new">ADD NEW</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="add-false">
                            ADD FALSE-CELING
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </Col>
                    <Col sm={9}>
                      <Tab.Content>
                        {living.map((item, i) => (
                          <Tab.Pane eventKey={item.name}>
                            <TextField
                              id="outlined-basic"
                              value={width}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth(e.target.value)}
                            /> &nbsp;&nbsp;
                            <TextField
                              id="outlined-basic"
                              value={width2}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth2(e.target.value)}
                            /><br/>
                            <br/>
                            <TextField
                              value={height}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight(e.target.value)}
                            />&nbsp;&nbsp;
                             <TextField
                              value={height2}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight2(e.target.value)}
                            />
                            
                           
                            <br />
                            <br />
                            <TextField
                              id="outlined-basic"
                              label="Name"
                              defaultValue={item.name}
                              variant="outlined"
                              onChange={(e) => setname(e.target.value)}
                            />
                            &nbsp;&nbsp;
                            <TextField
                              id="outlined-basic"
                              label="Rate"
                              defaultValue={item.rate}
                              variant="outlined"
                              onChange={(e) => setrate(e.target.value)}
                            />
                            <br />
                            <br />
                            <TextareaAutosize
                              aria-label="Description"
                              minRows={3}
                              className="textarea1"
                              defaultValue={item.desc}
                              onChange={(e) => setdesc(e.target.value)}
                              placeholder="Description"
                              style={{ width: 500 }}
                            />
                            <br />
                            <br />
                            <Button
                              onClick={() => {
                                // var totsq = height * width;
                                // var total = totsq * item.rate;
                                var th = parseFloat(height) + parseFloat(height2);
                                var tw = parseFloat(width) + parseFloat(width2);
                                var irate = rate == 0 ? item.rate : rate;
                                var totsq = th * tw;
                                var total =
                                  (Math.round(totsq * 10) / 10) * irate;
                                var descr = desc == "null" ? item.desc : desc;
                                var sname = name == "null" ? item.name : name;

                                setlivingtotal(livingtotal + total);

                                var newfield = {
                                  
                                  description: descr,
                                  name: sname,
                                   invoiceid: tname,
                                  tabname: "living",
                                  height: th,
                                  width: tw,
                                  totalsq: Math.round(totsq * 10) / 10,
                                  persq: irate,
                                  total: Math.round(total * 10) / 10,
                                };
                                setlivingtable([...livingtable, newfield]);
                                settemptable([newfield]);
                                setname("null");
                                setdesc("null");
                                setWidth(0);
                                setHeight(0);
                                setWidth2(0);
                                setHeight2(0);

                                setrate(0);
                                notify.show(
                                  "" + sname + " Added Sucessfully !",
                                  "success",
                                  2000
                                );
                              }}
                            >
                              Add
                            </Button>
                            &nbsp;
                            <Button
                              color="error"
                              onClick={() => {
                                try {
                                  axios
                                    .delete(
                                      "https://api.dremerz.net/api/latolivingdata/" +
                                        item.id +
                                        "/"
                                    )
                                    .then(() => {
                                      alert("Delete successful");
                                      getlivingData();
                                    });
                                } catch {
                                  alert("Error Occured");
                                }
                              }}
                            >
                              Delete
                            </Button>
                            &nbsp;
                            <Button
                              color="error"
                              onClick={() => {
                                try {
                                  var th = parseFloat(height) + parseFloat(height2);
                                var tw = parseFloat(width) + parseFloat(width2);
                                  var irate = rate == 0 ? item.rate : rate;
                                  var totsq = height * width;
                                  var total =
                                    (Math.round(totsq * 10) / 10) * irate;
                                  var descr = desc == "null" ? item.desc : desc;
                                  var sname = name == "null" ? item.name : name;

                                  var newfield = {
                                    name: sname,
                                    desc: descr,
                                    rate: irate,
                                  };
                                  axios
                                    .put(
                                      "https://api.dremerz.net/api/latolivingdata/" +
                                        item.id +
                                        "/",
                                      newfield
                                    )
                                    .then(() => {
                                      alert("Update Sucessful");
                                      getlivingData();
                                      setname("null");
                              setdesc("null");
                              setWidth(0);
                              setHeight(0);
                              setWidth2(0);
                              setHeight2(0);
                              setrate(0);
                                    });
                                } catch {
                                  alert("Error Occured");
                                }
                              }}
                            >
                              Update
                            </Button>
                          </Tab.Pane>
                        ))}
                        <Tab.Pane eventKey="add-new">
                        <TextField
                              id="outlined-basic"
                              value={width}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth(e.target.value)}
                            /> &nbsp;&nbsp;
                            <TextField
                              id="outlined-basic"
                              value={width2}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth2(e.target.value)}
                            /><br/>
                            <br/>
                            <TextField
                              value={height}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight(e.target.value)}
                            />&nbsp;&nbsp;
                             <TextField
                              value={height2}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight2(e.target.value)}
                            />
                         {" "}
                          <br />
                          <br />
                          <TextField
                            id="outlined-basic"
                            label="Rate"
                            variant="outlined"
                            value={rate}
                            onChange={(e) => setrate(e.target.value)}
                          />
                          &nbsp;&nbsp;
                          <TextField
                            id="outlined-basic"
                            label="Name"
                            value={name}
                            variant="outlined"
                            onChange={(e) => setname(e.target.value)}
                          />
                          <br />
                          <br />
                          <TextareaAutosize
                            aria-label="Description"
                            minRows={3}
                            className="textarea1"
                            onChange={(e) => setdesc(e.target.value)}
                            placeholder="Description"
                            value={desc}
                            style={{ width: 500 }}
                          />
                          <br />
                          <br />
                          <Button
                            onClick={() => {
                              var th = parseFloat(height) + parseFloat(height2);
                              var tw = parseFloat(width) + parseFloat(width2);
                              var totsq = th * tw;
                              var total = totsq * rate;
                              var descr = desc;

                              var newfield = {
                                description: descr,
                                invoiceid: tname,
                                tabname: "living",
                                name: name,
                                height: th,
                                width: tw,
                                totalsq: Math.round(totsq * 10) / 10,
                                persq: rate,
                                total: Math.round(total * 10) / 10,
                              };
                              setlivingtable([...livingtable, newfield]);
                              setlivingtotal(livingtotal + total);
                              settemptable([newfield]);
                              setname("null");
                              setdesc("null");
                              setWidth(0);
                              setHeight(0);
                              setWidth2(0);
                              setHeight2(0);
                              
                              setrate(0);
                              notify.show(
                                "" + name + " Added Sucessfully !",
                                "success",
                                2000
                              );
                            }}
                          >
                            Add
                          </Button>
                          &nbsp;&nbsp;
                          <Button
                            onClick={() => {
                              var totsq = height * width;
                              var total = totsq * rate;
                              var descr = desc;

                              var newfield = {
                                name: name,
                                desc: descr,
                                rate: rate,
                              };

                              try {
                                axios
                                  .post(
                                    "https://api.dremerz.net/api/latolivingdata/",
                                    newfield
                                  )
                                  .then((response) => {
                                    console.log(response);
                                    alert("Sucessfully Submited");
                                    getlivingData();
                                    setname("null");
                              setdesc("null");
                              setWidth(0);
                              setHeight(0);
                              setWidth2(0);
                              setHeight2(0);
                              setrate(0);
                                  })
                                  .catch((error) => {
                                    console.log(error);
                                    alert("Error Occured");
                                  });
                              } catch {
                                alert("Error Occured");
                              }
                            }}
                          >
                            Post
                          </Button>
                        </Tab.Pane>
                        <Tab.Pane eventKey="add-false">
                          <TextField
                            id="outlined-basic"
                            label="Name"
                            variant="outlined"
                            onChange={(e) =>
                              setname("*\t" + e.target.value + "\t*")
                            }
                          />
                          <br />
                          <br />
                         
                          <Button
                            onClick={() => {
                              var totsq = height * width;
                              var total = totsq * rate;
                              var descr = desc;
                              var sname = name == "null" ? item.name : name;

                              var newfield = {
                                description: "",
                                invoiceid: tname,
                                tabname: "living",
                                name: sname,
                                height: "",
                                width: "",
                                totalsq: "",
                                persq: "",
                                total: "",
                              };
                              setlivingtable([...livingtable, newfield]);
                              setname("null");
                              notify.show(
                                "" + sname + " Added Sucessfully !",
                                "success",
                                2000
                              );
                            }}
                          >
                            Add
                          </Button>
                          &nbsp;&nbsp;
                          <br/>
                          <br/>
                          <Button
                                  onClick={() => {
                                   

                                    var newfield = {
                                      description: "",
                                      invoiceid: tname,
                                      tabname: "living",
                                      name: "*\tSemi-False Ceiling\t*",
                                      height: "",
                                      width: "",
                                      totalsq: "",
                                      persq: "",
                                      total: "",
                                    };
                                    setlivingtable([
                                      ...livingtable,
                                      newfield,
                                    ]);
                                    setname("null");
                                    notify.show(
                                      "*\ Semi-False Ceiling\t* Added Sucessfully !",
                                      "success",
                                      2000
                                    );
                                  }}
                                >
                                 Semi-False ceiling
                                </Button>
                                &nbsp;
                                &nbsp;
                                <Button
                                  onClick={() => {
                                   

                                    var newfield = {
                                      description: "",
                                      invoiceid: tname,
                                      tabname: "living",
                                      name: "*\tFull-False Ceiling\t*",
                                      height: "",
                                      width: "",
                                      totalsq: "",
                                      persq: "",
                                      total: "",
                                    };
                                    setlivingtable([
                                      ...livingtable,
                                      newfield,
                                    ]);
                                    setname("null");
                                    notify.show(
                                      "*\ Full-False Ceiling\t* Added Sucessfully !",
                                      "success",
                                      2000
                                    );
                                  }}
                                >
                                 Full-False ceiling
                                </Button>
                        </Tab.Pane>
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
              </Tab>
              <Tab eventKey="Dining" title="Dining">
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                  <Row>
                    <Col sm={3}>
                      <Nav variant="pills" className="flex-column">
                        {dining.map((item, i) => (
                          <Nav.Item>
                            <Nav.Link eventKey={item.name}>
                              {item.name}
                            </Nav.Link>
                          </Nav.Item>
                        ))}
                        <Nav.Item>
                          <Nav.Link eventKey="add-new">ADD NEW</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="add-false">
                            ADD FALSE-CELING
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </Col>
                    <Col sm={9}>
                      <Tab.Content>
                        {dining.map((item, i) => (
                          <Tab.Pane eventKey={item.name}>
                             <TextField
                              id="outlined-basic"
                              value={width}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth(e.target.value)}
                            /> &nbsp;&nbsp;
                            <TextField
                              id="outlined-basic"
                              value={width2}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth2(e.target.value)}
                            /><br/>
                            <br/>
                            <TextField
                              value={height}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight(e.target.value)}
                            />&nbsp;&nbsp;
                             <TextField
                              value={height2}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight2(e.target.value)}
                            />
                            {" "}
                            <br />
                            <br />
                            <TextField
                              id="outlined-basic"
                              label="Name"
                              defaultValue={item.name}
                              variant="outlined"
                              onChange={(e) => setname(e.target.value)}
                            />
                            &nbsp;&nbsp;
                            <TextField
                              id="outlined-basic"
                              label="Rate"
                              defaultValue={item.rate}
                              variant="outlined"
                              onChange={(e) => setrate(e.target.value)}
                            />
                            <br />
                            <br />
                            <TextareaAutosize
                              aria-label="Description"
                              minRows={3}
                              className="textarea1"
                              defaultValue={item.desc}
                              onChange={(e) => setdesc(e.target.value)}
                              placeholder="Description"
                              style={{ width: 500 }}
                            />
                            <br />
                            <br />
                            <Button
                              onClick={() => {
                                var th = parseFloat(height) + parseFloat(height2);
                                var tw = parseFloat(width) + parseFloat(width2);
                                var irate = rate == 0 ? item.rate : rate;
                                var totsq = th * tw;
                                var total =
                                  (Math.round(totsq * 10) / 10) * irate;
                                var descr = desc == "null" ? item.desc : desc;
                                var sname = name == "null" ? item.name : name;

                                setdiningtotal(diningtotal + total);

                                var newfield = {
                                  
                                  description: descr,
                                  name: sname,
                                  invoiceid: tname,
                                  tabname: "dining",
                                  height: th,
                                  width: tw,
                                  totalsq: Math.round(totsq * 10) / 10,
                                  persq: irate,
                                  total: Math.round(total * 10) / 10,
                                };
                                setdiningtable([...diningtable, newfield]);
                                settemptable([newfield]);
                                setname("null");
                                setdesc("null");
                                setWidth(0);
                                setHeight(0);
                                setWidth2(0);
                                setHeight2(0);

                                setrate(0);
                                notify.show(
                                  "" + sname + " Added Sucessfully !",
                                  "success",
                                  2000
                                );
                              }}
                            >
                              Add
                            </Button>
                            &nbsp;
                            <Button
                              color="error"
                              onClick={() => {
                                try {
                                  axios
                                    .delete(
                                      "https://api.dremerz.net/api/latodiningdata/" +
                                        item.id +
                                        "/"
                                    )
                                    .then(() => {
                                      alert("Delete successful");
                                      getdiningData();
                                    });
                                } catch {
                                  alert("Error Occured");
                                }
                              }}
                            >
                              Delete
                            </Button>
                            &nbsp;
                            <Button
                              color="error"
                              onClick={() => {
                                try {
                                  var th = parseFloat(height) + parseFloat(height2);
                                var tw = parseFloat(width) + parseFloat(width2);
                                  var irate = rate == 0 ? item.rate : rate;
                                  var totsq = height * width;
                                  var total =
                                    (Math.round(totsq * 10) / 10) * irate;
                                  var descr = desc == "null" ? item.desc : desc;
                                  var sname = name == "null" ? item.name : name;

                                  var newfield = {
                                    name: sname,
                                    desc: descr,
                                    rate: irate,
                                  };
                                  axios
                                    .put(
                                      "https://api.dremerz.net/api/latodiningdata/" +
                                        item.id +
                                        "/",
                                      newfield
                                    )
                                    .then(() => {
                                      alert("Update Sucessful");
                                      getdiningData();
                                      setname("null");
                              setdesc("null");
                              setWidth(0);
                              setHeight(0);
                              setWidth2(0);
                              setHeight2(0);
                              setrate(0);
                                    });
                                } catch {
                                  alert("Error Occured");
                                }
                              }}
                            >
                              Update
                            </Button>
                          </Tab.Pane>
                        ))}
                        <Tab.Pane eventKey="add-new">
                        <TextField
                              id="outlined-basic"
                              value={width}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth(e.target.value)}
                            /> &nbsp;&nbsp;
                            <TextField
                              id="outlined-basic"
                              value={width2}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth2(e.target.value)}
                            /><br/>
                            <br/>
                            <TextField
                              value={height}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight(e.target.value)}
                            />&nbsp;&nbsp;
                             <TextField
                              value={height2}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight2(e.target.value)}
                            />
                          {" "}
                          <br />
                          <br />
                          <TextField
                            id="outlined-basic"
                            label="Rate"
                            variant="outlined"
                            value={rate}
                            onChange={(e) => setrate(e.target.value)}
                          />
                          &nbsp;&nbsp;
                          <TextField
                            id="outlined-basic"
                            label="Name"
                            value={name}
                            variant="outlined"
                            onChange={(e) => setname(e.target.value)}
                          />
                          <br />
                          <br />
                          <TextareaAutosize
                            aria-label="Description"
                            minRows={3}
                            className="textarea1"
                            onChange={(e) => setdesc(e.target.value)}
                            placeholder="Description"
                            value={desc}
                            style={{ width: 500 }}
                          />
                          <br />
                          <br />
                          <Button
                            onClick={() => {

                              var th  = parseFloat(height) + parseFloat(height2);
                              var tw = parseFloat(width)+ parseFloat(width2);
                              var totsq = height * width;
                              var total = totsq * rate;
                              var descr = desc;

                              var newfield = {
                                description: descr,
                                invoiceid: tname,
                                  tabname: "dining",
                                name: name,
                                height: th,
                                width: tw,
                                totalsq: Math.round(totsq * 10) / 10,
                                persq: rate,
                                total: Math.round(total * 10) / 10,
                              };
                              setdiningtable([...diningtable, newfield]);
                              setdiningtotal(diningtotal + total);
                              settemptable([newfield]);
                              setname("null");
                              setdesc("null");
                              setWidth(0);
                              setHeight(0);
                              setWidth2(0);
                              setHeight2(0);
                              setrate(0);
                              notify.show(
                                "" + name + " Added Sucessfully !",
                                "success",
                                2000
                              );
                            }}
                          >
                            Add
                          </Button>
                          &nbsp;&nbsp;
                          <Button
                            onClick={() => {
                              var totsq = height * width;
                              var total = totsq * rate;
                              var descr = desc;

                              var newfield = {
                                name: name,
                                desc: descr,
                                rate: rate,
                              };

                              try {
                                axios
                                  .post(
                                    "https://api.dremerz.net/api/latodiningdata/",
                                    newfield
                                  )
                                  .then((response) => {
                                    console.log(response);
                                    alert("Sucessfully Submited");
                                    getdiningData();
                                    setname("null");
                              setdesc("null");
                              setWidth(0);
                              setHeight(0);
                              setWidth2(0);
                              setHeight2(0);
                              setrate(0);
                                  })
                                  .catch((error) => {
                                    console.log(error);
                                    alert("Error Occured");
                                  });
                              } catch {
                                alert("Error Occured");
                              }
                            }}
                          >
                            Post
                          </Button>
                        </Tab.Pane>
                        <Tab.Pane eventKey="add-false">
                          <TextField
                            id="outlined-basic"
                            label="Name"
                            variant="outlined"
                            onChange={(e) =>
                              setname("*\t" + e.target.value + "\t*")
                            }
                          />
                          <br />
                          <br />
                          <Button
                            onClick={() => {
                              var totsq = height * width;
                              var total = totsq * rate;
                              var descr = desc;
                              var sname = name == "null" ? item.name : name;

                              var newfield = {
                                description: "",
                                invoiceid: tname,
                                  tabname: "dining",
                                name: sname,
                                height: "",
                                width: "",
                                totalsq: "",
                                persq: "",
                                total: "",
                              };
                              setdiningtable([...diningtable, newfield]);
                              setname("null");
                              notify.show(
                                "" + sname + " Added Sucessfully !",
                                "success",
                                2000
                              );
                            }}
                          >
                            Add
                          </Button>
                          <br/>
                          <br/>
                          <Button
                                  onClick={() => {
                                   

                                    var newfield = {
                                      description: "",
                                      invoiceid: tname,
                                      tabname: "dining",
                                      name: "*\tSemi-False Ceiling\t*",
                                      height: "",
                                      width: "",
                                      totalsq: "",
                                      persq: "",
                                      total: "",
                                    };
                                    setdiningtable([
                                      ...diningtable,
                                      newfield,
                                    ]);
                                    setname("null");
                                    notify.show(
                                      "*\ Semi-False Ceiling\t* Added Sucessfully !",
                                      "success",
                                      2000
                                    );
                                  }}
                                >
                                 Semi-False ceiling
                                </Button>
                                &nbsp;
                                &nbsp;
                                <Button
                                  onClick={() => {
                                   

                                    var newfield = {
                                      description: "",
                                      invoiceid: tname,
                                      tabname: "dining",
                                      name: "*\tFull-False Ceiling\t*",
                                      height: "",
                                      width: "",
                                      totalsq: "",
                                      persq: "",
                                      total: "",
                                    };
                                    setdiningtable([
                                      ...diningtable,
                                      newfield,
                                    ]);
                                    setname("null");
                                    notify.show(
                                      "*\ Full-False Ceiling\t* Added Sucessfully !",
                                      "success",
                                      2000
                                    );
                                  }}
                                >
                                 Full-False ceiling
                                </Button>
                          &nbsp;&nbsp;
                        </Tab.Pane>
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
              </Tab>
              <Tab eventKey="Showerroom" title="Master-bedroom">
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                  <Row>
                    <Col sm={3}>
                      <Nav variant="pills" className="flex-column">
                        {bedroom.map((item, i) => (
                          <Nav.Item>
                            <Nav.Link eventKey={item.name}>
                              {item.name}
                            </Nav.Link>
                          </Nav.Item>
                        ))}
                        <Nav.Item>
                          <Nav.Link eventKey="add-new">ADD NEW</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="add-false">
                            ADD FALSE-CELING
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </Col>
                    <Col sm={9}>
                      <Tab.Content>
                        {bedroom.map((item, i) => (
                          <Tab.Pane eventKey={item.name}>
                             <TextField
                              id="outlined-basic"
                              value={width}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth(e.target.value)}
                            /> &nbsp;&nbsp;
                            <TextField
                              id="outlined-basic"
                              value={width2}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth2(e.target.value)}
                            /><br/>
                            <br/>
                            <TextField
                              value={height}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight(e.target.value)}
                            />&nbsp;&nbsp;
                             <TextField
                              value={height2}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight2(e.target.value)}
                            />
                            {" "}
                            <br />
                            <br />
                            <TextField
                              id="outlined-basic"
                              label="Name"
                              defaultValue={item.name}
                              variant="outlined"
                              onChange={(e) => setname(e.target.value)}
                            />
                            &nbsp;&nbsp;
                            <TextField
                              id="outlined-basic"
                              label="Rate"
                              defaultValue={item.rate}
                              variant="outlined"
                              onChange={(e) => setrate(e.target.value)}
                            />
                            <br />
                            <br />
                            <TextareaAutosize
                              aria-label="Description"
                              minRows={3}
                              className="textarea1"
                              defaultValue={item.desc}
                              onChange={(e) => setdesc(e.target.value)}
                              placeholder="Description"
                              style={{ width: 500 }}
                            />
                            <br />
                            <br />
                            <Button
                              onClick={() => {
                                var th = parseFloat(height) + parseFloat(height2);
                                var tw = parseFloat(width) + parseFloat(width2);
                                var irate = rate == 0 ? item.rate : rate;
                                var totsq = th * tw;
                                var total =
                                  (Math.round(totsq * 10) / 10) * irate;
                                var descr = desc == "null" ? item.desc : desc;
                                var sname = name == "null" ? item.name : name;

                                setshowerroomtotal(showerroomtotal + total);

                                var newfield = {
                                  
                                  description: descr,
                                  name: sname,
                                  invoiceid: tname,
                                  tabname: "showerroom",
                                  height: th,
                                  width: tw,
                                  totalsq: Math.round(totsq * 10) / 10,
                                  persq: irate,
                                  total: Math.round(total * 10) / 10,
                                };
                                setshowerroomtable([
                                  ...showerroomtable,
                                  newfield,
                                ]);
                                settemptable([newfield]);
                                setname("null");
                                setdesc("null");
                                setWidth(0);
                                setHeight(0);
                                setWidth2(0);
                                setHeight2(0);

                                setrate(0);
                                notify.show(
                                  "" + sname + " Added Sucessfully !",
                                  "success",
                                  2000
                                );
                              }}
                            >
                              Add
                            </Button>
                            &nbsp;
                            <Button
                              color="error"
                              onClick={() => {
                                try {
                                  axios
                                    .delete(
                                      "https://api.dremerz.net/api/latobedroomdata/" +
                                        item.id +
                                        "/"
                                    )
                                    .then(() => {
                                      alert("Delete successful");
                                      getbedroomData();
                                    });
                                } catch {
                                  alert("Error Occured");
                                }
                              }}
                            >
                              Delete
                            </Button>
                            &nbsp;
                            <Button
                              color="error"
                              onClick={() => {
                                try {
                                  var th = parseFloat(height) + parseFloat(height2);
                                var tw = parseFloat(width) + parseFloat(width2);
                                  var irate = rate == 0 ? item.rate : rate;
                                  var totsq = height * width;
                                  var total =
                                    (Math.round(totsq * 10) / 10) * irate;
                                  var descr = desc == "null" ? item.desc : desc;
                                  var sname = name == "null" ? item.name : name;

                                  var newfield = {
                                    name: sname,
                                    desc: descr,
                                    rate: irate,
                                  };
                                  axios
                                    .put(
                                      "https://api.dremerz.net/api/latobedroomdata/" +
                                        item.id +
                                        "/",
                                      newfield
                                    )
                                    .then(() => {
                                      alert("Update Sucessful");
                                      getbedroomData();
                                      setname("null");
                              setdesc("null");
                              setWidth(0);
                              setHeight(0);
                              setWidth2(0);
                              setHeight2(0);
                              setrate(0);
                                    });
                                } catch {
                                  alert("Error Occured");
                                }
                              }}
                            >
                              Update
                            </Button>
                          </Tab.Pane>
                        ))}
                        <Tab.Pane eventKey="add-new">
                        <TextField
                              id="outlined-basic"
                              value={width}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth(e.target.value)}
                            /> &nbsp;&nbsp;
                            <TextField
                              id="outlined-basic"
                              value={width2}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth2(e.target.value)}
                            /><br/>
                            <br/>
                            <TextField
                              value={height}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight(e.target.value)}
                            />&nbsp;&nbsp;
                             <TextField
                              value={height2}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight2(e.target.value)}
                            />
                          {" "}
                          <br />
                          <br />
                          <TextField
                            id="outlined-basic"
                            label="Rate"
                            variant="outlined"
                            value={rate}
                            onChange={(e) => setrate(e.target.value)}
                          />
                          &nbsp;&nbsp;
                          <TextField
                            id="outlined-basic"
                            label="Name"
                            value={name}
                            variant="outlined"
                            onChange={(e) => setname(e.target.value)}
                          />
                          <br />
                          <br />
                          <TextareaAutosize
                            aria-label="Description"
                            minRows={3}
                            className="textarea1"
                            onChange={(e) => setdesc(e.target.value)}
                            placeholder="Description"
                            value={desc}
                            style={{ width: 500 }}
                          />
                          <br />
                          <br />
                          <Button
                            onClick={() => {
                              var th  = parseFloat(height) + parseFloat(height2);
                              var tw = parseFloat(width) + parseFloat(width2);
                              var totsq = th * tw;
                              var total = totsq * rate;
                              var descr = desc;

                              var newfield = {
                                description: descr,
                                invoiceid: tname,
                                  tabname: "showerroom",
                                name: name,
                                height: th,
                                width: tw,
                                totalsq: Math.round(totsq * 10) / 10,
                                persq: rate,
                                total: Math.round(total * 10) / 10,
                              };
                              setshowerroomtable([
                                ...showerroomtable,
                                newfield,
                              ]);
                              setshowerroomtotal(showerroomtotal + total);
                              settemptable([newfield]);
                              setname("null");
                              setdesc("null");
                              setWidth(0);
                              setHeight(0);
                              setWidth2(0);
                              setHeight2(0);
                              setrate(0);
                              notify.show(
                                "" + name + " Added Sucessfully !",
                                "success",
                                2000
                              );
                            }}
                          >
                            Add
                          </Button>
                          &nbsp;&nbsp;
                          <Button
                            onClick={() => {
                              var totsq = height * width;
                              var total = totsq * rate;
                              var descr = desc;

                              var newfield = {
                                name: name,
                                desc: descr,
                                rate: rate,
                              };

                              try {
                                axios
                                  .post(
                                    "https://api.dremerz.net/api/latobedroomdata/",
                                    newfield
                                  )
                                  .then((response) => {
                                    console.log(response);
                                    alert("Sucessfully Submited");
                                    getbedroomData();
                                    setname("null");
                              setdesc("null");
                              setWidth(0);
                              setHeight(0);
                              setWidth2(0);
                              setHeight2(0);
                              setrate(0);
                                  })
                                  .catch((error) => {
                                    console.log(error);
                                    alert("Error Occured");
                                  });
                              } catch {
                                alert("Error Occured");
                              }
                            }}
                          >
                            Post
                          </Button>
                        </Tab.Pane>
                        <Tab.Pane eventKey="add-false">
                          <TextField
                            id="outlined-basic"
                            label="Name"
                            variant="outlined"
                            onChange={(e) =>
                              setname("*\t" + e.target.value + "\t*")
                            }
                          />
                          <br />
                          <br />
                          <Button
                            onClick={() => {
                              var totsq = height * width;
                              var total = totsq * rate;
                              var descr = desc;
                              var sname = name == "null" ? item.name : name;

                              var newfield = {
                                description: "",
                                name: sname,
                                invoiceid: tname,
                                  tabname: "showerroom",
                                height: "",
                                width: "",
                                totalsq: "",
                                persq: "",
                                total: "",
                              };
                              setshowerroomtable([
                                ...showerroomtable,
                                newfield,
                              ]);
                              setname("null");
                              notify.show(
                                "" + sname + " Added Sucessfully !",
                                "success",
                                2000
                              );
                            }}
                          >
                            Add
                          </Button>
                          <br/>
                          <br/>
                          <Button
                                  onClick={() => {
                                   

                                    var newfield = {
                                      description: "",
                                      invoiceid: tname,
                                      tabname: "showerroom",
                                      name: "*\tSemi-False Ceiling\t*",
                                      height: "",
                                      width: "",
                                      totalsq: "",
                                      persq: "",
                                      total: "",
                                    };
                                    setshowerroomtable([
                                      ...showerroomtable,
                                      newfield,
                                    ]);
                                    setname("null");
                                    notify.show(
                                      "*\ Semi-False Ceiling\t* Added Sucessfully !",
                                      "success",
                                      2000
                                    );
                                  }}
                                >
                                 Semi-False ceiling
                                </Button>
                                &nbsp;
                                &nbsp;
                                <Button
                                  onClick={() => {
                                   

                                    var newfield = {
                                      description: "",
                                      invoiceid: tname,
                                      tabname: "showerroom",
                                      name: "*\tFull-False Ceiling\t*",
                                      height: "",
                                      width: "",
                                      totalsq: "",
                                      persq: "",
                                      total: "",
                                    };
                                    setshowerroomtable([
                                      ...showerroomtable,
                                      newfield,
                                    ]);
                                    setname("null");
                                    notify.show(
                                      "*\ Full-False Ceiling\t* Added Sucessfully !",
                                      "success",
                                      2000
                                    );
                                  }}
                                >
                                 Full-False ceiling
                                </Button>
                          &nbsp;&nbsp;
                        </Tab.Pane>
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
              </Tab>
              <Tab eventKey="Bedroom" title="Bedroom">
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                  <Row>
                    <Col sm={3}>
                      <Nav variant="pills" className="flex-column">
                        {bedroom.map((item, i) => (
                          <Nav.Item>
                            <Nav.Link eventKey={item.name}>
                              {item.name}
                            </Nav.Link>
                          </Nav.Item>
                        ))}
                        <Nav.Item>
                          <Nav.Link eventKey="add-new">ADD NEW</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="add-false">
                            ADD FALSE-CELING
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="add-bedroom">
                            ADD BEDROOM
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </Col>
                    <Col sm={9}>
                      <Tab.Content>
                        {bedroom.map((item, i) => (
                          <Tab.Pane eventKey={item.name}>
                             <TextField
                              id="outlined-basic"
                              value={width}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth(e.target.value)}
                            /> &nbsp;&nbsp;
                            <TextField
                              id="outlined-basic"
                              value={width2}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth2(e.target.value)}
                            /><br/>
                            <br/>
                            <TextField
                              value={height}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight(e.target.value)}
                            />&nbsp;&nbsp;
                             <TextField
                              value={height2}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight2(e.target.value)}
                            />
                            {" "}
                            <br />
                            <br />
                            <TextField
                              id="outlined-basic"
                              label="Name"
                              defaultValue={item.name}
                              variant="outlined"
                              onChange={(e) => setname(e.target.value)}
                            />
                            &nbsp;&nbsp;
                            <TextField
                              id="outlined-basic"
                              label="Rate"
                              defaultValue={item.rate}
                              variant="outlined"
                              onChange={(e) => setrate(e.target.value)}
                            />
                            <br />
                            <br />
                            <TextareaAutosize
                              aria-label="Description"
                              minRows={3}
                              className="textarea1"
                              defaultValue={item.desc}
                              onChange={(e) => setdesc(e.target.value)}
                              placeholder="Description"
                              style={{ width: 500 }}
                            />
                            <br />
                            <br />
                            <Button
                              onClick={() => {
                                var th = parseFloat(height) + parseFloat(height2);
                                var tw = parseFloat(width) + parseFloat(width2);
                                var irate = rate == 0 ? item.rate : rate;
                                var totsq = th * tw;
                                var total =
                                  (Math.round(totsq * 10) / 10) * irate;
                                var descr = desc == "null" ? item.desc : desc;
                                var sname = name == "null" ? item.name : name;

                                setbedroomtotal(bedroomtotal + total);

                                var newfield = {
                                  
                                  description: descr,
                                  name: sname,
                                   invoiceid: tname,
                                  tabname: "bedroom",
                                  height: th,
                                  width: tw,
                                  totalsq: Math.round(totsq * 10) / 10,
                                  persq: irate,
                                  total: Math.round(total * 10) / 10,
                                };
                                setbedroomtable([...bedroomtable, newfield]);
                                settemptable([newfield]);
                                setname("null");
                                setdesc("null");
                                setWidth(0);
                                setHeight(0);
                                setWidth2(0);
                                setHeight2(0);

                                setrate(0);
                                notify.show(
                                  "" + sname + " Added Sucessfully !",
                                  "success",
                                  2000
                                );
                              }}
                            >
                              Add
                            </Button>
                            &nbsp;
                            <Button
                              color="error"
                              onClick={() => {
                                try {
                                  axios
                                    .delete(
                                      "https://api.dremerz.net/api/latobedroomdata/" +
                                        item.id +
                                        "/"
                                    )
                                    .then(() => {
                                      alert("Delete successful");
                                      getbedroomData();
                                    });
                                } catch {
                                  alert("Error Occured");
                                }
                              }}
                            >
                              Delete
                            </Button>
                            &nbsp;
                            <Button
                              color="error"
                              onClick={() => {
                                try {
                                  var th = parseFloat(height) + parseFloat(height2);
                                var tw = parseFloat(width) + parseFloat(width2);
                                  var irate = rate == 0 ? item.rate : rate;
                                  var totsq = th * tw;
                                  var total =
                                    (Math.round(totsq * 10) / 10) * irate;
                                  var descr = desc == "null" ? item.desc : desc;
                                  var sname = name == "null" ? item.name : name;

                                  var newfield = {
                                    name: sname,
                                    desc: descr,
                                    rate: irate,
                                  };
                                  axios
                                    .put(
                                      "https://api.dremerz.net/api/latobedroomdata/" +
                                        item.id +
                                        "/",
                                      newfield
                                    )
                                    .then(() => {
                                      alert("Update Sucessful");
                                      getbedroomData();
                                      setname("null");
                              setdesc("null");
                              setWidth(0);
                              setHeight(0);
                              setWidth2(0);
                              setHeight2(0);
                              setrate(0);
                                    });
                                } catch {
                                  alert("Error Occured");
                                }
                              }}
                            >
                              Update
                            </Button>
                          </Tab.Pane>
                        ))}
                        <Tab.Pane eventKey="add-new">
                        <TextField
                              id="outlined-basic"
                              value={width}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth(e.target.value)}
                            /> &nbsp;&nbsp;
                            <TextField
                              id="outlined-basic"
                              value={width2}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth2(e.target.value)}
                            /><br/>
                            <br/>
                            <TextField
                              value={height}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight(e.target.value)}
                            />&nbsp;&nbsp;
                             <TextField
                              value={height2}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight2(e.target.value)}
                            />
                         {" "}
                          <br />
                          <br />
                          <TextField
                            id="outlined-basic"
                            label="Rate"
                            variant="outlined"
                            value={rate}
                            onChange={(e) => setrate(e.target.value)}
                          />
                          &nbsp;&nbsp;
                          <TextField
                            id="outlined-basic"
                            label="Name"
                            value={name}
                            variant="outlined"
                            onChange={(e) => setname(e.target.value)}
                          />
                          <br />
                          <br />
                          <TextareaAutosize
                            aria-label="Description"
                            minRows={3}
                            className="textarea1"
                            onChange={(e) => setdesc(e.target.value)}
                            placeholder="Description"
                            value={desc}
                            style={{ width: 500 }}
                          />
                          <br />
                          <br />
                          <Button
                            onClick={() => {
                              var th = parseFloat(height) + parseFloat(height2);
                              var tw = parseFloat(width) + parseFloat(width2);
                              var totsq = th * tw;
                              var total = totsq * rate;
                              var descr = desc;

                              var newfield = {
                                description: descr,
                                invoiceid: tname,
                                  tabname: "bedroom",
                                name: name,
                                height: th,
                                width: tw,
                                totalsq: Math.round(totsq * 10) / 10,
                                persq: rate,
                                total: Math.round(total * 10) / 10,
                              };
                              setbedroomtable([...bedroomtable, newfield]);
                              setbedroomtotal(bedroomtotal + total);
                              settemptable([newfield]);
                              setname("null");
                              setdesc("null");
                              setWidth(0);
                              setHeight(0);
                              setWidth2(0);
                              setHeight2(0);
                              setrate(0);
                              notify.show(
                                "" + name + " Added Sucessfully !",
                                "success",
                                2000
                              );
                            }}
                          >
                            Add
                          </Button>
                          &nbsp;&nbsp;
                          <Button
                            onClick={() => {
                              var totsq = height * width;
                              var total = totsq * rate;
                              var descr = desc;

                              var newfield = {
                                name: name,
                                desc: descr,
                                rate: rate,
                              };

                              try {
                                axios
                                  .post(
                                    "https://api.dremerz.net/api/latobedroomdata/",
                                    newfield
                                  )
                                  .then((response) => {
                                    console.log(response);
                                    alert("Sucessfully Submited");
                                    getbedroomData();
                                    setname("null");
                              setdesc("null");
                              setWidth(0);
                              setHeight(0);
                              setWidth2(0);
                              setHeight2(0);
                              setrate(0);
                                  })
                                  .catch((error) => {
                                    console.log(error);
                                    alert("Error Occured");
                                  });
                              } catch {
                                alert("Error Occured");
                              }
                            }}
                          >
                            Post
                          </Button>
                        </Tab.Pane>
                        <Tab.Pane eventKey="add-bedroom">
                          <TextField
                            id="outlined-basic"
                            label="Name"
                            variant="outlined"
                            onChange={(e) =>
                              setname("*\t" + e.target.value + "\t*")
                            }
                          />
                          <br />
                          <br />
                          <Button
                            onClick={() => {
                              var totsq = height * width;
                              var total = totsq * rate;
                              var descr = desc;
                              var sname = name == "null" ? item.name : name;

                              var newfield = {
                                description: "",
                                invoiceid: tname,
                                  tabname: "bedroom",
                                name: sname,
                                height: "",
                                width: "",
                                totalsq: "",
                                persq: "",
                                total: "",
                              };
                              setbedroomtable([...bedroomtable, newfield]);
                              setname("null");
                              notify.show(
                                "" + sname + " Added Sucessfully !",
                                "success",
                                2000
                              );
                            }}
                          >
                            Add
                          </Button>
                          &nbsp;&nbsp;
                        </Tab.Pane>
                        <Tab.Pane eventKey="add-false">
                          <TextField
                            id="outlined-basic"
                            label="Name"
                            variant="outlined"
                            onChange={(e) =>
                              setname("*\t" + e.target.value + "\t*")
                            }
                          />
                          <br />
                          <br />
                          <Button
                            onClick={() => {
                              var totsq = height * width;
                              var total = totsq * rate;
                              var descr = desc;
                              var sname = name == "null" ? item.name : name;

                              var newfield = {
                                description: "",
                                invoiceid: tname,
                                  tabname: "bedroom",
                                name: sname,
                                height: "",
                                width: "",
                                totalsq: "",
                                persq: "",
                                total: "",
                              };
                              setbedroomtable([...bedroomtable, newfield]);
                              setname("null");
                              notify.show(
                                "" + sname + " Added Sucessfully !",
                                "success",
                                2000
                              );
                            }}
                          >
                            Add
                          </Button>
                          <br/>
                          <br/>
                          <Button
                                  onClick={() => {
                                   

                                    var newfield = {
                                      description: "",
                                      invoiceid: tname,
                                      tabname: "bedroom",
                                      name: "*\tSemi-False Ceiling\t*",
                                      height: "",
                                      width: "",
                                      totalsq: "",
                                      persq: "",
                                      total: "",
                                    };
                                    setbedroomtable([
                                      ...bedroomtable,
                                      newfield,
                                    ]);
                                    setname("null");
                                    notify.show(
                                      "*\ Semi-False Ceiling\t* Added Sucessfully !",
                                      "success",
                                      2000
                                    );
                                  }}
                                >
                                 Semi-False ceiling
                                </Button>
                                &nbsp;
                                &nbsp;
                                <Button
                                  onClick={() => {
                                   

                                    var newfield = {
                                      description: "",
                                      invoiceid: tname,
                                      tabname: "bedroom",
                                      name: "*\tFull-False Ceiling\t*",
                                      height: "",
                                      width: "",
                                      totalsq: "",
                                      persq: "",
                                      total: "",
                                    };
                                    setbedroomtable([
                                      ...bedroomtable,
                                      newfield,
                                    ]);
                                    setname("null");
                                    notify.show(
                                      "*\ Full-False Ceiling\t* Added Sucessfully !",
                                      "success",
                                      2000
                                    );
                                  }}
                                >
                                 Full-False ceiling
                                </Button>
                          &nbsp;&nbsp;
                        </Tab.Pane>
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
              </Tab>
              <Tab eventKey="Other" title="Kids-bedroom">
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                  <Row>
                    <Col sm={3}>
                      <Nav variant="pills" className="flex-column">
                        {bedroom.map((item, i) => (
                          <Nav.Item>
                            <Nav.Link eventKey={item.name}>
                              {item.name}
                            </Nav.Link>
                          </Nav.Item>
                        ))}
                        <Nav.Item>
                          <Nav.Link eventKey="add-new">ADD NEW</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="add-false">
                            ADD FALSE-CELING
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </Col>
                    <Col sm={9}>
                      <Tab.Content>
                        {bedroom.map((item, i) => (
                          <Tab.Pane eventKey={item.name}>
                            <TextField
                              id="outlined-basic"
                              value={width}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth(e.target.value)}
                            /> &nbsp;&nbsp;
                            <TextField
                              id="outlined-basic"
                              value={width2}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth2(e.target.value)}
                            /><br/>
                            <br/>
                            <TextField
                              value={height}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight(e.target.value)}
                            />&nbsp;&nbsp;
                             <TextField
                              value={height2}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight2(e.target.value)}
                            />
                           
                            {" "}
                            <br />
                            <br />
                            <TextField
                              id="outlined-basic"
                              label="Name"
                              defaultValue={item.name}
                              variant="outlined"
                              onChange={(e) => setname(e.target.value)}
                            />
                            &nbsp;&nbsp;
                            <TextField
                              id="outlined-basic"
                              label="Rate"
                              defaultValue={item.rate}
                              variant="outlined"
                              onChange={(e) => setrate(e.target.value)}
                            />
                            <br />
                            <br />
                            <TextareaAutosize
                              aria-label="Description"
                              minRows={3}
                              className="textarea1"
                              defaultValue={item.desc}
                              onChange={(e) => setdesc(e.target.value)}
                              placeholder="Description"
                              style={{ width: 500 }}
                            />
                            <br />
                            <br />
                            <Button
                              onClick={() => {
                                var th = parseFloat(height) + parseFloat(height2);
                                var tw = parseFloat(width) + parseFloat(width2);
                                var irate = rate == 0 ? item.rate : rate;
                                var totsq = th * tw;
                                var total =
                                  (Math.round(totsq * 10) / 10) * irate;
                                var descr = desc == "null" ? item.desc : desc;
                                var sname = name == "null" ? item.name : name;

                                setothertotal(othertotal + total);

                                var newfield = {
                                  
                                  description: descr,
                                  name: sname,
                                  invoiceid: tname,
                                  tabname: "other",
                                  height: th,
                                  width: tw,
                                  totalsq: Math.round(totsq * 10) / 10,
                                  persq: irate,
                                  total: Math.round(total * 10) / 10,
                                };
                                setothertable([...othertable, newfield]);
                                settemptable([newfield]);
                                setname("null");
                                setdesc("null");
                                setWidth(0);
                                setHeight(0);
                                setWidth2(0);
                                setHeight2(0);

                                setrate(0);
                                notify.show(
                                  "" + sname + " Added Sucessfully !",
                                  "success",
                                  2000
                                );
                              }}
                            >
                              Add
                            </Button>
                            &nbsp;
                            <Button
                              color="error"
                              onClick={() => {
                                try {
                                  axios
                                    .delete(
                                      "https://api.dremerz.net/api/latobedroomdata/" +
                                        item.id +
                                        "/"
                                    )
                                    .then(() => {
                                      alert("Delete successful");
                                      getbedroomData();
                                    });
                                } catch {
                                  alert("Error Occured");
                                }
                              }}
                            >
                              Delete
                            </Button>
                            &nbsp;
                            <Button
                              color="error"
                              onClick={() => {
                                try {
                                  var th = parseFloat(height) + parseFloat(height2);
                                var tw = parseFloat(width) + parseFloat(width2);
                                  var irate = rate == 0 ? item.rate : rate;
                                  var totsq = height * width;
                                  var total =
                                    (Math.round(totsq * 10) / 10) * irate;
                                  var descr = desc == "null" ? item.desc : desc;
                                  var sname = name == "null" ? item.name : name;

                                  var newfield = {
                                    name: sname,
                                    desc: descr,
                                    rate: irate,
                                  };
                                  axios
                                    .put(
                                      "https://api.dremerz.net/api/latobedroomdata/" +
                                        item.id +
                                        "/",
                                      newfield
                                    )
                                    .then(() => {
                                      alert("Update Sucessful");
                                      getbedroomData();
                                      setname("null");
                              setdesc("null");
                              setWidth(0);
                              setHeight(0);
                              setWidth2(0);
                              setHeight2(0);
                              setrate(0);
                                    });
                                } catch {
                                  alert("Error Occured");
                                }
                              }}
                            >
                              Update
                            </Button>
                          </Tab.Pane>
                        ))}
                        <Tab.Pane eventKey="add-new">
                        <TextField
                              id="outlined-basic"
                              value={width}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth(e.target.value)}
                            /> &nbsp;&nbsp;
                            <TextField
                              id="outlined-basic"
                              value={width2}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth2(e.target.value)}
                            /><br/>
                            <br/>
                            <TextField
                              value={height}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight(e.target.value)}
                            />&nbsp;&nbsp;
                             <TextField
                              value={height2}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight2(e.target.value)}
                            />
                          {" "}
                          <br />
                          <br />
                          <TextField
                            id="outlined-basic"
                            label="Rate"
                            variant="outlined"
                            value={rate}
                            onChange={(e) => setrate(e.target.value)}
                          />
                          &nbsp;&nbsp;
                          <TextField
                            id="outlined-basic"
                            label="Name"
                            value={name}
                            variant="outlined"
                            onChange={(e) => setname(e.target.value)}
                          />
                          <br />
                          <br />
                          <TextareaAutosize
                            aria-label="Description"
                            minRows={3}
                            className="textarea1"
                            onChange={(e) => setdesc(e.target.value)}
                            placeholder="Description"
                            value={desc}
                            style={{ width: 500 }}
                          />
                          <br />
                          <br />
                          <Button
                            onClick={() => {
                              var th = parseFloat(height) + parseFloat(height2);
                              var tw = parseFloat(width) + parseFloat(width2);
                              var totsq = th * tw;
                              var total = totsq * rate;
                              var descr = desc;

                              var newfield = {
                                description: descr,
                                invoiceid: tname,
                                  tabname: "other",
                                name: name,
                                height: th,
                                width: tw,
                                totalsq: Math.round(totsq * 10) / 10,
                                persq: rate,
                                total: Math.round(total * 10) / 10,
                              };
                              setothertable([...othertable, newfield]);
                              setothertotal(othertotal + total);
                              settemptable([newfield]);
                              setname("null");
                              setdesc("null");
                              setWidth(0);
                              setHeight(0);
                              setWidth2(0);
                              setHeight2(0);
                              setrate(0);
                              notify.show(
                                "" + name + " Added Sucessfully !",
                                "success",
                                2000
                              );
                            }}
                          >
                            Add
                          </Button>
                          &nbsp;&nbsp;
                          <Button
                            onClick={() => {
                              var totsq = height * width;
                              var total = totsq * rate;
                              var descr = desc;

                              var newfield = {
                                name: name,
                                desc: descr,
                                rate: rate,
                              };

                              try {
                                axios
                                  .post(
                                    "https://api.dremerz.net/api/latobedroomdata/",
                                    newfield
                                  )
                                  .then((response) => {
                                    console.log(response);
                                    alert("Sucessfully Submited");
                                    getbedroomData();
                                    setname("null");
                              setdesc("null");
                              setWidth(0);
                              setHeight(0);
                              setWidth2(0);
                              setHeight2(0);
                              setrate(0);
                                  })
                                  .catch((error) => {
                                    console.log(error);
                                    alert("Error Occured");
                                  });
                              } catch {
                                alert("Error Occured");
                              }
                            }}
                          >
                            Post
                          </Button>
                        </Tab.Pane>
                        <Tab.Pane eventKey="add-false">
                          <TextField
                            id="outlined-basic"
                            label="Name"
                            variant="outlined"
                            onChange={(e) =>
                              setname("*\t" + e.target.value + "\t*")
                            }
                          />
                          <br />
                          <br />
                          <Button
                            onClick={() => {
                              var totsq = height * width;
                              var total = totsq * rate;
                              var descr = desc;
                              var sname = name == "null" ? item.name : name;

                              var newfield = {
                                description: "",
                                invoiceid: tname,
                                  tabname: "other",
                                name: sname,
                                height: "",
                                width: "",
                                totalsq: "",
                                persq: "",
                                total: "",
                              };
                              setothertable([...othertable, newfield]);
                              setname("null");
                              notify.show(
                                "" + sname + " Added Sucessfully !",
                                "success",
                                2000
                              );
                            }}
                          >
                            Add
                          </Button>
                          <br/>
                          <br/>
                          <Button
                                  onClick={() => {
                                   

                                    var newfield = {
                                      description: "",
                                      invoiceid: tname,
                                      tabname: "other",
                                      name: "*\tSemi-False Ceiling\t*",
                                      height: "",
                                      width: "",
                                      totalsq: "",
                                      persq: "",
                                      total: "",
                                    };
                                    setothertable([
                                      ...othertable,
                                      newfield,
                                    ]);
                                    setname("null");
                                    notify.show(
                                      "*\ Semi-False Ceiling\t* Added Sucessfully !",
                                      "success",
                                      2000
                                    );
                                  }}
                                >
                                 Semi-False ceiling
                                </Button>
                                &nbsp;
                                &nbsp;
                                <Button
                                  onClick={() => {
                                   

                                    var newfield = {
                                      description: "",
                                      invoiceid: tname,
                                      tabname: "other",
                                      name: "*\tFull-False Ceiling\t*",
                                      height: "",
                                      width: "",
                                      totalsq: "",
                                      persq: "",
                                      total: "",
                                    };
                                    setothertable([
                                      ...othertable,
                                      newfield,
                                    ]);
                                    setname("null");
                                    notify.show(
                                      "*\ Full-False Ceiling\t* Added Sucessfully !",
                                      "success",
                                      2000
                                    );
                                  }}
                                >
                                 Full-False ceiling
                                </Button>
                          &nbsp;&nbsp;
                        </Tab.Pane>
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
              </Tab>
              <Tab eventKey="Bedroom-features" title="Bedroom-features">
                      <table>
                        <tr>
                          <td>
                          <Button
                                  onClick={() => {
                                   

                                    var newfield = {
                                      description: "",
                                      invoiceid: tname,
                                      tabname: "bedroom",
                                      name: "*\tBedroom 1\t*",
                                      height: "",
                                      width: "",
                                      totalsq: "",
                                      persq: "",
                                      total: "",
                                    };
                                    setbedroomtable([
                                      ...bedroomtable,
                                      newfield,
                                    ]);
                                    setname("null");
                                    notify.show(
                                      "*\tBedroom 1\t* Added Sucessfully !",
                                      "success",
                                      2000
                                    );
                                  }}
                                >
                                 Bedroom 1
                                </Button>
                          </td>
                          <td>
                          <Button
                                  onClick={() => {
                                   

                                    var newfield = {
                                      description: "",
                                      invoiceid: tname,
                                      tabname: "bedroom",
                                      name: "*\tBedroom 2\t*",
                                      height: "",
                                      width: "",
                                      totalsq: "",
                                      persq: "",
                                      total: "",
                                    };
                                    setbedroomtable([
                                      ...bedroomtable,
                                      newfield,
                                    ]);
                                    setname("null");
                                    notify.show(
                                      "*\tBedroom 2\t* Added Sucessfully !",
                                      "success",
                                      2000
                                    );
                                  }}
                                >
                                 Bedroom 2
                                </Button>
                          </td>
                          <td>
                          <Button
                                  onClick={() => {
                                   

                                    var newfield = {
                                      description: "",
                                      invoiceid: tname,
                                      tabname: "bedroom",
                                      name: "*\tBedroom 3\t*",
                                      height: "",
                                      width: "",
                                      totalsq: "",
                                      persq: "",
                                      total: "",
                                    };
                                    setbedroomtable([
                                      ...bedroomtable,
                                      newfield,
                                    ]);
                                    setname("null");
                                    notify.show(
                                      "*\tBedroom 3\t* Added Sucessfully !",
                                      "success",
                                      2000
                                    );
                                  }}
                                >
                                 Bedroom 3
                                </Button>
                          </td>
                        </tr>
                        <tr>
                          <td>
                          <Button
                                  onClick={() => {
                                   

                                    var newfield = {
                                      description: "",
                                      invoiceid: tname,
                                      tabname: "bedroom",
                                      name: "*\tMaster-Bedroom\t*",
                                      height: "",
                                      width: "",
                                      totalsq: "",
                                      persq: "",
                                      total: "",
                                    };
                                    setbedroomtable([
                                      ...bedroomtable,
                                      newfield,
                                    ]);
                                    setname("null");
                                    notify.show(
                                      "*\tMaster-Bedroom\t* Added Sucessfully !",
                                      "success",
                                      2000
                                    );
                                  }}
                                >
                                 Master-Bedroom
                                </Button>
                          </td>
                          <td>
                          <Button
                                  onClick={() => {
                                   

                                    var newfield = {
                                      description: "",
                                      invoiceid: tname,
                                      tabname: "bedroom",
                                      name: "*\tKids-Bedroom\t*",
                                      height: "",
                                      width: "",
                                      totalsq: "",
                                      persq: "",
                                      total: "",
                                    };
                                    setbedroomtable([
                                      ...bedroomtable,
                                      newfield,
                                    ]);
                                    setname("null");
                                    notify.show(
                                      "*\tKids-Bedroom\t* Added Sucessfully !",
                                      "success",
                                      2000
                                    );
                                  }}
                                >
                                 Kids-Bedroom
                                </Button>
                          </td>
                          <td>
                          <Button
                                  onClick={() => {
                                   

                                    var newfield = {
                                      description: "",
                                      invoiceid: tname,
                                      tabname: "bedroom",
                                      name: "*\tGuest-Bedroom\t*",
                                      height: "",
                                      width: "",
                                      totalsq: "",
                                      persq: "",
                                      total: "",
                                    };
                                    setbedroomtable([
                                      ...bedroomtable,
                                      newfield,
                                    ]);
                                    setname("null");
                                    notify.show(
                                      "*\tGuest-Bedroom\t* Added Sucessfully !",
                                      "success",
                                      2000
                                    );
                                  }}
                                >
                                 Guest-Bedroom
                                </Button>
                          </td>
                        </tr>
                      </table>

                      <br />
                      <br />
                    </Tab>
              <Tab eventKey="Kitchen" title="Kitchen">
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                  <Row>
                    <Col sm={3}>
                      <Nav variant="pills" className="flex-column">
                        {kicthen.map((item, i) => (
                          <Nav.Item>
                            <Nav.Link eventKey={item.name}>
                              {item.name}
                            </Nav.Link>
                          </Nav.Item>
                        ))}
                        <Nav.Item>
                          <Nav.Link eventKey="add-new">ADD NEW</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="add-false">
                            ADD FALSE-CELING
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </Col>
                    <Col sm={9}>
                      <Tab.Content>
                        {kicthen.map((item, i) => (
                          <Tab.Pane eventKey={item.name}>
                             <TextField
                              id="outlined-basic"
                              value={width}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth(e.target.value)}
                            /> &nbsp;&nbsp;
                            <TextField
                              id="outlined-basic"
                              value={width2}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth2(e.target.value)}
                            /><br/>
                            <br/>
                            <TextField
                              value={height}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight(e.target.value)}
                            />&nbsp;&nbsp;
                             <TextField
                              value={height2}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight2(e.target.value)}
                            />
                            {" "}
                            <br />
                            <br />
                            <TextField
                              id="outlined-basic"
                              label="Name"
                              defaultValue={item.name}
                              variant="outlined"
                              onChange={(e) => setname(e.target.value)}
                            />
                            &nbsp;&nbsp;
                            <TextField
                              id="outlined-basic"
                              label="Rate"
                              defaultValue={item.rate}
                              variant="outlined"
                              onChange={(e) => setrate(e.target.value)}
                            />
                            <br />
                            <br />
                            <TextareaAutosize
                              aria-label="Description"
                              minRows={3}
                              className="textarea1"
                              defaultValue={item.desc}
                              onChange={(e) => setdesc(e.target.value)}
                              placeholder="Description"
                              style={{ width: 500 }}
                            />
                            <br />
                            <br />
                            <Button
                              onClick={() => {
                                var th = parseFloat(height) + parseFloat(height2);
                                var tw = parseFloat(width) + parseFloat(width2);
                                var irate = rate == 0 ? item.rate : rate;
                                var totsq = th * tw;
                                var total =
                                  (Math.round(totsq * 10) / 10) * irate;
                                var descr = desc == "null" ? item.desc : desc;
                                var sname = name == "null" ? item.name : name;

                                setkicthentotal(kicthentotal + total);

                                var newfield = {
                                  
                                  description: descr,
                                  name: sname,
                                  invoiceid: tname,
                                  tabname: "kicthen",
                                  height: th,
                                  width: tw,
                                  totalsq: Math.round(totsq * 10) / 10,
                                  persq: irate,
                                  total: Math.round(total * 10) / 10,
                                };
                                setkicthentable([...kicthentable, newfield]);
                                settemptable([newfield]);
                                setname("null");
                                setdesc("null");
                                setWidth(0);
                                setHeight(0);
                                setWidth2(0);
                                setHeight2(0);

                                setrate(0);
                                notify.show(
                                  "" + sname + " Added Sucessfully !",
                                  "success",
                                  2000
                                );
                              }}
                            >
                              Add
                            </Button>
                            &nbsp;
                            <Button
                              color="error"
                              onClick={() => {
                                try {
                                  axios
                                    .delete(
                                      "https://api.dremerz.net/api/latokicthendata/" +
                                        item.id +
                                        "/"
                                    )
                                    .then(() => {
                                      alert("Delete successful");
                                      getkicthenData();
                                    });
                                } catch {
                                  alert("Error Occured");
                                }
                              }}
                            >
                              Delete
                            </Button>
                            &nbsp;
                            <Button
                              color="error"
                              onClick={() => {
                                try {
                                  var th = parseFloat(height) + parseFloat(height2);
                                var tw = parseFloat(width) + parseFloat(width2);
                                  var irate = rate == 0 ? item.rate : rate;
                                  var totsq = height * width;
                                  var total =
                                    (Math.round(totsq * 10) / 10) * irate;
                                  var descr = desc == "null" ? item.desc : desc;
                                  var sname = name == "null" ? item.name : name;

                                  var newfield = {
                                    name: sname,
                                    desc: descr,
                                    rate: irate,
                                  };
                                  axios
                                    .put(
                                      "https://api.dremerz.net/api/latokicthendata/" +
                                        item.id +
                                        "/",
                                      newfield
                                    )
                                    .then(() => {
                                      alert("Update Sucessful");
                                      getkicthenData();
                                      setname("null");
                              setdesc("null");
                              setWidth(0);
                              setHeight(0);
                              setWidth2(0);
                              setHeight2(0);
                              setrate(0);
                                    });
                                } catch {
                                  alert("Error Occured");
                                }
                              }}
                            >
                              Update
                            </Button>
                          </Tab.Pane>
                        ))}
                        <Tab.Pane eventKey="add-new">
                        <TextField
                              id="outlined-basic"
                              value={width}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth(e.target.value)}
                            /> &nbsp;&nbsp;
                            <TextField
                              id="outlined-basic"
                              value={width2}
                              label="Width"
                              variant="outlined"
                              onChange={(e) => setWidth2(e.target.value)}
                            /><br/>
                            <br/>
                            <TextField
                              value={height}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight(e.target.value)}
                            />&nbsp;&nbsp;
                             <TextField
                              value={height2}
                              id="outlined-basic"
                              label="Height"
                              variant="outlined"
                              onChange={(e) => setHeight2(e.target.value)}
                            />
                         
                          {" "}
                          <br />
                          <br />
                          <TextField
                            id="outlined-basic"
                            label="Rate"
                            variant="outlined"
                            value={rate}
                            onChange={(e) => setrate(e.target.value)}
                          />
                          &nbsp;&nbsp;
                          <TextField
                            id="outlined-basic"
                            label="Name"
                            value={name}
                            variant="outlined"
                            onChange={(e) => setname(e.target.value)}
                          />
                          <br />
                          <br />
                          <TextareaAutosize
                            aria-label="Description"
                            minRows={3}
                            className="textarea1"
                            onChange={(e) => setdesc(e.target.value)}
                            placeholder="Description"
                            value={desc}
                            style={{ width: 500 }}
                          />
                          <br />
                          <br />
                          <Button
                            onClick={() => {
                              var th  =parseFloat(height) + parseFloat(height2);
                              var tw = parseFloat(width) + parseFloat(width2);
                              var totsq = th * tw;
                              var total = totsq * rate;
                              var descr = desc;

                              var newfield = {
                                description: descr,
                                invoiceid: tname,
                                  tabname: "kicthen",
                                name: name,
                                height: th,
                                width: tw,
                                totalsq: Math.round(totsq * 10) / 10,
                                persq: rate,
                                total: Math.round(total * 10) / 10,
                              };
                              setkicthentable([...kicthentable, newfield]);
                              setkicthentotal(kicthentotal + total);
                              settemptable([newfield]);
                              setname("null");
                              setdesc("null");
                              setWidth(0);
                              setHeight(0);
                              setWidth2(0);
                              setHeight2(0);
                              setrate(0);
                              notify.show(
                                "" + name + " Added Sucessfully !",
                                "success",
                                2000
                              );
                            }}
                          >
                            Add
                          </Button>
                          &nbsp;&nbsp;
                          <Button
                            onClick={() => {
                              var totsq = height * width;
                              var total = totsq * rate;
                              var descr = desc;

                              var newfield = {
                                name: name,
                                desc: desc,
                                rate: rate,
                              };

                              try {
                                axios
                                  .post(
                                    "https://api.dremerz.net/api/latokicthendata/",
                                    newfield
                                  )
                                  .then((response) => {
                                    console.log(newfield);

                                    console.log(response);
                                    alert("Sucessfully Submited");
                                    getkicthenData();
                                    setname("null");
                              setdesc("null");
                              setWidth(0);
                              setHeight(0);
                              setWidth2(0);
                              setHeight2(0);
                              setrate(0);
                                  })
                                  .catch((error) => {
                                    console.log(newfield);

                                    console.log(error);
                                    alert("Error Occured");
                                  });
                              } catch {
                                alert("Error Occured");
                              }
                            }}
                          >
                            Post
                          </Button>
                        </Tab.Pane>
                        <Tab.Pane eventKey="add-false">
                          <TextField
                            id="outlined-basic"
                            label="Name"
                            variant="outlined"
                            onChange={(e) =>
                              setname("*\t" + e.target.value + "\t*")
                            }
                          />

                          <br />
                          <br />
                          <Button
                            onClick={() => {
                              var totsq = height * width;
                              var total = totsq * rate;
                              var descr = desc;
                              var sname = name == "null" ? item.name : name;

                              var newfield = {
                                description: "",
                                invoiceid: tname,
                                  tabname: "kicthen",
                                name: sname,
                                height: "",
                                width: "",
                                totalsq: "",
                                persq: "",
                                total: "",
                              };
                              setkicthentable([...kicthentable, newfield]);
                              setname("null");
                              notify.show(
                                "" + sname + " Added Sucessfully !",
                                "success",
                                2000
                              );
                            }}
                          >
                            Add
                          </Button>
                          &nbsp;&nbsp;
                          <br/>
                          <br/>
                          <Button
                                  onClick={() => {
                                   

                                    var newfield = {
                                      description: "",
                                      invoiceid: tname,
                                      tabname: "kicthen",
                                      name: "*\tSemi-False Ceiling\t*",
                                      height: "",
                                      width: "",
                                      totalsq: "",
                                      persq: "",
                                      total: "",
                                    };
                                    setkicthentable([
                                      ...kicthentable,
                                      newfield,
                                    ]);
                                    setname("null");
                                    notify.show(
                                      "*\ Semi-False Ceiling\t* Added Sucessfully !",
                                      "success",
                                      2000
                                    );
                                  }}
                                >
                                 Semi-False ceiling
                                </Button>
                                &nbsp;
                                &nbsp;
                                <Button
                                  onClick={() => {
                                   

                                    var newfield = {
                                      description: "",
                                      invoiceid: tname,
                                      tabname: "kicthen",
                                      name: "*\tFull-False Ceiling\t*",
                                      height: "",
                                      width: "",
                                      totalsq: "",
                                      persq: "",
                                      total: "",
                                    };
                                    setkicthentable([
                                      ...kicthentable,
                                      newfield,
                                    ]);
                                    setname("null");
                                    notify.show(
                                      "*\ Full-False Ceiling\t* Added Sucessfully !",
                                      "success",
                                      2000
                                    );
                                  }}
                                >
                                 Full-False ceiling
                                </Button>
                        </Tab.Pane>
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
              </Tab>
            </Tabs>
            )}
          </div>
        </div>
        <div className="Upc12">
          <div className="dmain">
            <Notifications />
            <div className="dm22">
              <div className="dc1">
                TO &nbsp; &nbsp; &nbsp; &nbsp;
                <table className="tabdet">
                  <tr>
                    <td> Name</td>
                    <td>
                      <TextField
                        id="outlined-basic"
                        className="inpt1ft"
                        variant="standard"
                        onChange={(e) => settname(e.target.value)}
                      />
                      <br />
                    </td>
                  </tr>

                  <tr>
                    <td>Email</td>
                    <td>
                      {" "}
                      <TextField
                        id="outlined-basic"
                        variant="standard"
                        className="inpt1ft"
                        onChange={(e) => settmail(e.target.value)}
                      />
                      <br />
                    </td>
                  </tr>
                  <tr>
                    <td>Phone</td>
                    <td>
                      {" "}
                      <TextField
                        id="outlined-basic"
                        variant="standard"
                        className="inpt1ft"
                        onChange={(e) => settphone(e.target.value)}
                      />
                      <br />
                    </td>
                  </tr>
                  <tr>
                    <td>Address</td>
                    <td>
                      {" "}
                      <TextField
                        id="outlined-basic"
                        variant="standard"
                        className="inpt1ft"
                        onChange={(e) => settaddress(e.target.value)}
                      />
                      <br />
                    </td>
                  </tr>
                </table>
              </div>
              <div className="dc2">
              <table className="ucaltab">
                      <tr className="uctr">
                        <td className="ucaltb1">Name</td>
                        <td className="ucaltb1">Description</td>
                        <td className="ucaltb1">Width</td>
                        <td className="ucaltb1">Height</td>
                        <td className="ucaltb1">Total Sq</td>
                        <td className="ucaltb1">Per Sq</td>
                        <td className="ucaltb1">Total</td>
                      </tr>
                      {temptable.map((input, index) => {
                        return (
                          <tr className="uctr">
                            <td className="ucaltb2">{input.name}</td>
                            <td className="ucaltb2">{input.description}</td>
                            <td className="ucaltb2">{input.width}</td>
                            <td className="ucaltb2">{input.height}</td>
                            <td className="ucaltb2">{input.totalsq}</td>
                            <td className="ucaltb2">{input.persq}</td>
                            <td className="ucaltb2">{input.total}</td>
                          </tr>
                        );
                      })}
                    </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="upc2">
        <div className="upc21">
          {foyertable.length == 0 ? null : (
            <>
              <div className="titletable"> FOYER</div>
              <table className="ucaltab">
                <tr className="uctr">
                  <td className="ucaltb1">Sno</td>

                  <td className="ucaltb1">Name</td>
                  <td className="ucaltb1">Description</td>
                  
                  <td className="ucaltb1">Width</td>
                  <td className="ucaltb1">Height</td>
                  <td className="ucaltb1">Total Sq</td>
                  <td className="ucaltb1">Per Sq</td>
                  <td className="ucaltb1">Total</td>
                  <td className="ucaltb123">ACTIONS</td>
                </tr>
                {foyertable.map((input, index) => {
                  return (
                    <tr className="uctr">
                      <td className="ucaltb2">{index + 1}</td>

                      <td className="ucaltb2">{input.name}</td>
                      <td className="ucaltb2">{input.description}</td>
                      <td className="ucaltb2">{input.width}</td>
                      <td className="ucaltb2">{input.height}</td>
                      <td className="ucaltb2">{input.totalsq}</td>
                      <td className="ucaltb2">{input.persq}</td>
                      <td className="ucaltb2">{input.total}</td>
                      <td className="ucaltb2">
                        <Button
                          onClick={() => {
                            let data = [...foyertable];
                            data.splice(index, 1);
                            setfoyertable(data);
                            setfoyertotal(foyertotal - input.total);
                          }}
                        >
                          <BiTrashAlt />
                        </Button>
                        &nbsp;
                        <Button
                          onClick={() => {
                            if (index > 0) {
                              let data = [...foyertable];
                              console.log(data);
                              console.log("data");
                              let dummy = [];
                              dummy[0] = data[index];
                              data[index] = data[index - 1];
                              data[index - 1] = dummy[0];

                              setfoyertable(data);
                              console.log(data);
                              notify.show(" Row Moved Up  !", "info", 2000);
                            } else {
                              alert("Not Valid ");
                            }
                          }}
                        >
                          &uarr;
                        </Button>
                        &nbsp;
                        <Button
                          onClick={() => {
                            if (index < foyertable.length - 1) {
                              let data = [...foyertable];
                              console.log(data);
                              console.log("data");
                              let dummy = [];
                              dummy[0] = data[index];
                              data[index] = data[index + 1];
                              data[index + 1] = dummy[0];

                              setfoyertable(data);
                              console.log(data);
                              notify.show(" Row Moved Down  !", "info", 2000);
                            } else {
                              alert("Not Valid !");
                            }
                          }}
                        >
                          &darr;
                        </Button>
                      </td>
                    </tr>
                  );
                })}

                <tr className="uctr">
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>

                  <td className="ucaltb3"></td>
                </tr>
                <tr className="uctr">
                  <td className="ucaltb4" colSpan={7}>
                    {" "}
                    TOTAL AMOUNT
                  </td>

                  <td className="ucaltb41" colSpan={2}>
                    {foyertotal}
                  </td>
                </tr>
              </table>
            </>
          )}
        </div>
        <div className="upc22">
          {livingtable.length == 0 ? null : (
            <>
              <div className="titletable"> LIVING</div>

              <table className="ucaltab">
                <tr className="uctr">
                  <td className="ucaltb1">Sno</td>
                  <td className="ucaltb1">Name</td>
                  <td className="ucaltb1">Description</td>
                  
                  <td className="ucaltb1">Width</td>
                  <td className="ucaltb1">Height</td>
                  <td className="ucaltb1">Total Sq</td>
                  <td className="ucaltb1">Per Sq</td>
                  <td className="ucaltb1">Total</td>
                  <td className="ucaltb123">ACTIONS</td>
                </tr>
                {livingtable.map((input, index) => {
                  return (
                    <tr className="uctr">
                      <td className="ucaltb2">{index + 1}</td>

                      <td className="ucaltb2">{input.name}</td>
                      <td className="ucaltb2">{input.description}</td>
                      
                      <td className="ucaltb2">{input.width}</td>
                      <td className="ucaltb2">{input.height}</td>
                      <td className="ucaltb2">{input.totalsq}</td>
                      <td className="ucaltb2">{input.persq}</td>
                      <td className="ucaltb2">{input.total}</td>
                      <td className="ucaltb2">
                        <Button
                          onClick={() => {
                            let data = [...livingtable];
                            data.splice(index, 1);
                            setlivingtable(data);
                            setlivingtotal(livingtotal - input.total);
                          }}
                        >
                          <BiTrashAlt />
                        </Button>
                        &nbsp;
                        <Button
                          onClick={() => {
                            if (index > 0) {
                              let data = [...livingtable];
                              console.log(data);
                              console.log("data");
                              let dummy = [];
                              dummy[0] = data[index];
                              data[index] = data[index - 1];
                              data[index - 1] = dummy[0];

                              setlivingtable(data);
                              console.log(data);
                              notify.show(" Row Moved Up  !", "info", 2000);
                            } else {
                              alert("Not Valid ");
                            }
                          }}
                        >
                          &uarr;
                        </Button>
                        &nbsp;
                        <Button
                          onClick={() => {
                            if (index < livingtable.length - 1) {
                              let data = [...livingtable];
                              console.log(data);
                              console.log("data");
                              let dummy = [];
                              dummy[0] = data[index];
                              data[index] = data[index + 1];
                              data[index + 1] = dummy[0];

                              setlivingtable(data);
                              console.log(data);
                              notify.show(" Row Moved Down  !", "info", 2000);
                            } else {
                              alert("Not Valid !");
                            }
                          }}
                        >
                          &darr;
                        </Button>
                      </td>
                    </tr>
                  );
                })}

                <tr className="uctr">
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                </tr>
                <tr className="uctr">
                  <td className="ucaltb4" colSpan={7}>
                    {" "}
                    TOTAL AMOUNT
                  </td>

                  <td className="ucaltb41" colSpan={2}>
                    {livingtotal}
                  </td>
                </tr>
              </table>

              <br />
            </>
          )}
        </div>
      </div>
      <div className="upc2">
        <div className="upc21">
          {diningtable.length == 0 ? null : (
            <>
              <div className="titletable"> DINING</div>
              <table className="ucaltab">
                <tr className="uctr">
                  <td className="ucaltb1">Sno</td>
                  <td className="ucaltb1">Name</td>
                  <td className="ucaltb1">Description</td>
                  
                  <td className="ucaltb1">Width</td>
                  <td className="ucaltb1">Height</td>
                  <td className="ucaltb1">Total Sq</td>
                  <td className="ucaltb1">Per Sq</td>
                  <td className="ucaltb1">Total</td>
                  <td className="ucaltb123">ACTIONS</td>
                </tr>
                {diningtable.map((input, index) => {
                  return (
                    <tr className="uctr">
                      <td className="ucaltb2">{index + 1}</td>

                      <td className="ucaltb2">{input.name}</td>
                      <td className="ucaltb2">{input.description}</td>
                      
                      <td className="ucaltb2">{input.width}</td>
                      <td className="ucaltb2">{input.height}</td>
                      <td className="ucaltb2">{input.totalsq}</td>
                      <td className="ucaltb2">{input.persq}</td>
                      <td className="ucaltb2">{input.total}</td>
                      <td className="ucaltb2">
                        <Button
                          onClick={() => {
                            let data = [...diningtable];
                            data.splice(index, 1);
                            setdiningtable(data);
                            setdiningtotal(diningtotal - input.total);
                          }}
                        >
                          <BiTrashAlt />
                        </Button>
                        &nbsp;
                        <Button
                          onClick={() => {
                            if (index > 0) {
                              let data = [...diningtable];
                              console.log(data);
                              console.log("data");
                              let dummy = [];
                              dummy[0] = data[index];
                              data[index] = data[index - 1];
                              data[index - 1] = dummy[0];

                              setdiningtable(data);
                              console.log(data);
                              notify.show(" Row Moved Up  !", "info", 2000);
                            } else {
                              alert("Not Valid ");
                            }
                          }}
                        >
                          &uarr;
                        </Button>
                        &nbsp;
                        <Button
                          onClick={() => {
                            if (index < diningtable.length - 1) {
                              let data = [...diningtable];
                              console.log(data);
                              console.log("data");
                              let dummy = [];
                              dummy[0] = data[index];
                              data[index] = data[index + 1];
                              data[index + 1] = dummy[0];

                              setdiningtable(data);
                              console.log(data);
                              notify.show(" Row Moved Down  !", "info", 2000);
                            } else {
                              alert("Not Valid !");
                            }
                          }}
                        >
                          &darr;
                        </Button>
                      </td>
                    </tr>
                  );
                })}

                <tr className="uctr">
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                </tr>
                <tr className="uctr">
                  <td className="ucaltb4" colSpan={7}>
                    TOTAL AMOUNT
                  </td>

                  <td className="ucaltb41" colSpan={2}>
                    {diningtotal}
                  </td>
                </tr>
              </table>
              <br />
            </>
          )}
        </div>
        <div className="upc22">
          {showerroomtable.length == 0 ? null : (
            <>
              <div className="titletable"> MASTER-BEDROOM</div>
              <table className="ucaltab">
                <tr className="uctr">
                  <td className="ucaltb1">Sno</td>
                  <td className="ucaltb1">Name</td>
                  <td className="ucaltb1">Description</td>
                  
                  <td className="ucaltb1">Width</td>
                  <td className="ucaltb1">Height</td>
                  <td className="ucaltb1">Total Sq</td>
                  <td className="ucaltb1">Per Sq</td>
                  <td className="ucaltb1">Total</td>
                  <td className="ucaltb123">ACTIONS</td>
                </tr>
                {showerroomtable.map((input, index) => {
                  return (
                    <tr className="uctr">
                      <td className="ucaltb2">{index + 1}</td>

                      <td className="ucaltb2">{input.name}</td>
                      <td className="ucaltb2">{input.description}</td>
                      
                      <td className="ucaltb2">{input.width}</td>
                      <td className="ucaltb2">{input.height}</td>
                      <td className="ucaltb2">{input.totalsq}</td>
                      <td className="ucaltb2">{input.persq}</td>
                      <td className="ucaltb2">{input.total}</td>
                      <td className="ucaltb2">
                        <Button
                          onClick={() => {
                            let data = [...showerroomtable];
                            data.splice(index, 1);
                            setshowerroomtable(data);
                            setshowerroomtotal(showerroomtotal - input.total);
                          }}
                        >
                          <BiTrashAlt />
                        </Button>
                        &nbsp;
                        <Button
                          onClick={() => {
                            if (index > 0) {
                              let data = [...showerroomtable];
                              console.log(data);
                              console.log("data");
                              let dummy = [];
                              dummy[0] = data[index];
                              data[index] = data[index - 1];
                              data[index - 1] = dummy[0];

                              setshowerroomtable(data);
                              console.log(data);
                              notify.show(" Row Moved Up  !", "info", 2000);
                            } else {
                              alert("Not Valid ");
                            }
                          }}
                        >
                          &uarr;
                        </Button>
                        &nbsp;
                        <Button
                          onClick={() => {
                            if (index < showerroomtable.length - 1) {
                              let data = [...showerroomtable];
                              console.log(data);
                              console.log("data");
                              let dummy = [];
                              dummy[0] = data[index];
                              data[index] = data[index + 1];
                              data[index + 1] = dummy[0];

                              setshowerroomtable(data);
                              console.log(data);
                              notify.show(" Row Moved Down  !", "info", 2000);
                            } else {
                              alert("Not Valid !");
                            }
                          }}
                        >
                          &darr;
                        </Button>
                      </td>
                    </tr>
                  );
                })}

                <tr className="uctr">
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                </tr>
                <tr className="uctr">
                  <td className="ucaltb4" colSpan={7}>
                    {" "}
                    TOTAL AMOUNT
                  </td>

                  <td className="ucaltb41" colSpan={2}>
                    {showerroomtotal}
                  </td>
                </tr>
              </table>
              <br />
            </>
          )}
        </div>
      </div>
      <div className="upc2">
        <div className="upc21">
          {bedroomtable.length == 0 ? null : (
            <>
              <div className="titletable"> BEDROOM</div>
              <table className="ucaltab">
                <tr className="uctr">
                  <td className="ucaltb1">Sno</td>
                  <td className="ucaltb1">Name</td>
                  <td className="ucaltb1">Description</td>
                  
                  <td className="ucaltb1">Width</td>
                  <td className="ucaltb1">Height</td>
                  <td className="ucaltb1">Total Sq</td>
                  <td className="ucaltb1">Per Sq</td>
                  <td className="ucaltb1">Total</td>
                  <td className="ucaltb123">ACTIONS</td>
                </tr>
                {bedroomtable.map((input, index) => {
                  return (
                    <tr className="uctr">
                      <td className="ucaltb2">{index + 1}</td>

                      <td className="ucaltb2">{input.name}</td>
                      <td className="ucaltb2">{input.description}</td>
                      
                      <td className="ucaltb2">{input.width}</td>
                      <td className="ucaltb2">{input.height}</td>
                      <td className="ucaltb2">{input.totalsq}</td>
                      <td className="ucaltb2">{input.persq}</td>
                      <td className="ucaltb2">{input.total}</td>
                      <td className="ucaltb2">
                        <Button
                          onClick={() => {
                            let data = [...bedroomtable];
                            data.splice(index, 1);
                            setbedroomtable(data);
                            setbedroomtotal(bedroomtotal - input.total);
                          }}
                        >
                          <BiTrashAlt />
                        </Button>
                        &nbsp;
                        <Button
                          onClick={() => {
                            if (index > 0) {
                              let data = [...bedroomtable];
                              console.log(data);
                              console.log("data");
                              let dummy = [];
                              dummy[0] = data[index];
                              data[index] = data[index - 1];
                              data[index - 1] = dummy[0];

                              setbedroomtable(data);
                              console.log(data);
                              notify.show(" Row Moved Up  !", "info", 2000);
                            } else {
                              alert("Not Valid ");
                            }
                          }}
                        >
                          &uarr;
                        </Button>
                        &nbsp;
                        <Button
                          onClick={() => {
                            if (index < bedroomtable.length - 1) {
                              let data = [...bedroomtable];
                              console.log(data);
                              console.log("data");
                              let dummy = [];
                              dummy[0] = data[index];
                              data[index] = data[index + 1];
                              data[index + 1] = dummy[0];

                              setbedroomtable(data);
                              console.log(data);
                              notify.show(" Row Moved Down  !", "info", 2000);
                            } else {
                              alert("Not Valid !");
                            }
                          }}
                        >
                          &darr;
                        </Button>
                      </td>
                    </tr>
                  );
                })}

                <tr className="uctr">
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                </tr>
                <tr className="uctr">
                  <td className="ucaltb4" colSpan={7}>
                    {" "}
                    TOTAL AMOUNT
                  </td>

                  <td className="ucaltb41" colSpan={2}>
                    {bedroomtotal}
                  </td>
                </tr>
              </table>
              <br />
            </>
          )}
        </div>
        <div className="upc22">
          {kicthentable.length == 0 ? null : (
            <>
              <div className="titletable"> KICTHEN</div>
              <table className="ucaltab">
                <tr className="uctr">
                  <td className="ucaltb1">Sno</td>
                  <td className="ucaltb1">Name</td>
                  <td className="ucaltb1">Description</td>
                  <td className="ucaltb1">Width</td>
                  <td className="ucaltb1">Height</td>
                  <td className="ucaltb1">Total Sq</td>
                  <td className="ucaltb1">Per Sq</td>
                  <td className="ucaltb1">Total</td>
                  <td className="ucaltb123">ACTIONS</td>
                </tr>
                {kicthentable.map((input, index) => {
                  return (
                    <tr className="uctr">
                      <td className="ucaltb2">{index + 1}</td>

                      <td className="ucaltb2">{input.name}</td>
                      <td className="ucaltb2">{input.description}</td>
                      <td className="ucaltb2">{input.width}</td>
                      <td className="ucaltb2">{input.height}</td>
                      <td className="ucaltb2">{input.totalsq}</td>
                      <td className="ucaltb2">{input.persq}</td>
                      <td className="ucaltb2">{input.total}</td>
                      <td className="ucaltb2">
                        <Button
                          onClick={() => {
                            let data = [...kicthentable];
                            data.splice(index, 1);
                            setkicthentable(data);
                            setkicthentotal(kicthentotal - input.total);
                          }}
                        >
                          <BiTrashAlt />
                        </Button>
                        &nbsp;
                        <Button
                          onClick={() => {
                            if (index > 0) {
                              let data = [...kicthentable];
                              console.log(data);
                              console.log("data");
                              let dummy = [];
                              dummy[0] = data[index];
                              data[index] = data[index - 1];
                              data[index - 1] = dummy[0];

                              setkicthentable(data);
                              console.log(data);
                              notify.show(" Row Moved Up  !", "info", 2000);
                            } else {
                              alert("Not Valid ");
                            }
                          }}
                        >
                          &uarr;
                        </Button>
                        &nbsp;
                        <Button
                          onClick={() => {
                            if (index < kicthentable.length - 1) {
                              let data = [...kicthentable];
                              console.log(data);
                              console.log("data");
                              let dummy = [];
                              dummy[0] = data[index];
                              data[index] = data[index + 1];
                              data[index + 1] = dummy[0];

                              setkicthentable(data);
                              console.log(data);
                              notify.show(" Row Moved Down  !", "info", 2000);
                            } else {
                              alert("Not Valid !");
                            }
                          }}
                        >
                          &darr;
                        </Button>
                      </td>
                    </tr>
                  );
                })}

                <tr className="uctr">
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                  <td className="ucaltb3"></td>
                </tr>
                <tr className="uctr">
                  <td className="ucaltb4" colSpan={7}>
                    {" "}
                    TOTAL AMOUNT
                  </td>

                  <td className="ucaltb41" colSpan={2}>
                    {kicthentotal}
                  </td>
                </tr>
              </table>
            </>
          )}
        </div>
      </div>
      <div className="upc3">
        {othertable.length == 0 ? null : (
          <>
            <div className="titletable"> KIDS-BEDROOM</div>
            <table className="ucaltab">
              <tr className="uctr">
                <td className="ucaltb1">Sno</td>
                <td className="ucaltb1">Name</td>
                <td className="ucaltb1">Description</td>
                
                <td className="ucaltb1">Width</td>
                <td className="ucaltb1">Height</td>
                <td className="ucaltb1">Total Sq</td>
                <td className="ucaltb1">Per Sq</td>
                <td className="ucaltb1">Total</td>
                <td className="ucaltb123">ACTIONS</td>
              </tr>
              {othertable.map((input, index) => {
                return (
                  <tr className="uctr">
                    <td className="ucaltb2">{index + 1}</td>

                    <td className="ucaltb2">{input.name}</td>
                    <td className="ucaltb2">{input.description}</td>
                    <td className="ucaltb2">{input.width}</td>
                    <td className="ucaltb2">{input.height}</td>
                    <td className="ucaltb2">{input.totalsq}</td>
                    <td className="ucaltb2">{input.persq}</td>
                    <td className="ucaltb2">{input.total}</td>
                    <td className="ucaltb2">
                      <Button
                        onClick={() => {
                          let data = [...othertable];
                          data.splice(index, 1);
                          setothertable(data);
                          setothertotal(othertotal - input.total);
                        }}
                      >
                        <BiTrashAlt />
                      </Button>
                      &nbsp;
                      <Button
                        onClick={() => {
                          if (index > 0) {
                            let data = [...othertable];
                            console.log(data);
                            console.log("data");
                            let dummy = [];
                            dummy[0] = data[index];
                            data[index] = data[index - 1];
                            data[index - 1] = dummy[0];

                            setothertable(data);
                            console.log(data);
                            notify.show(" Row Moved Up  !", "info", 2000);
                          } else {
                            alert("Not Valid ");
                          }
                        }}
                      >
                        &uarr;
                      </Button>
                      &nbsp;
                      <Button
                        onClick={() => {
                          if (index < othertable.length - 1) {
                            let data = [...othertable];
                            console.log(data);
                            console.log("data");
                            let dummy = [];
                            dummy[0] = data[index];
                            data[index] = data[index + 1];
                            data[index + 1] = dummy[0];

                            setothertable(data);
                            console.log(data);
                            notify.show(" Row Moved Down  !", "info", 2000);
                          } else {
                            alert("Not Valid !");
                          }
                        }}
                      >
                        &darr;
                      </Button>
                    </td>
                  </tr>
                );
              })}

              <tr className="uctr">
                <td className="ucaltb3"></td>
                <td className="ucaltb3"></td>
                <td className="ucaltb3"></td>
                <td className="ucaltb3"></td>
                <td className="ucaltb3"></td>
                <td className="ucaltb3"></td>
                <td className="ucaltb3"></td>
                <td className="ucaltb3"></td>
                <td className="ucaltb3"></td>
              </tr>
              <tr className="uctr">
                <td className="ucaltb4" colSpan={7}>
                  {" "}
                  TOTAL AMOUNT
                </td>

                <td className="ucaltb41" colSpan={2}>
                  {Math.round(othertotal)}
                </td>
              </tr>
            </table>
          </>
        )}
        <div className="upc21"></div>
        <div className="upc22"></div>
      </div>

      {/* <div className="dmain">
        <Notifications />
     
      </div> */}
      {/* <div className="cal1">
       
      </div> */}
      <div>
        <div className="cal12"></div>
      </div>
      <div className="calcmain">
        <div className="cal1">
          <table className="ucaltab">
            <tr className="uctr">
              <td className="ucaltb1">Sno</td>

              <td className="ucaltb1">Name</td>
              <td className="ucaltb1">Description</td>
              <td className="ucaltb1">Width</td>
              <td className="ucaltb1">Height</td>
              <td className="ucaltb1">Total Sq</td>
              <td className="ucaltb1">Per Sq</td>
              <td className="ucaltb1">Total</td>
              <td className="ucaltb123">ACTIONS</td>
            </tr>
            {/*  */}

            <tr className="uctr">
              <td className="ucaltb3"></td>
              <td className="ucaltb3"></td>
              <td className="ucaltb3"></td>
              <td className="ucaltb3"></td>
              <td className="ucaltb3"></td>
              <td className="ucaltb3"></td>
              <td className="ucaltb3"></td>
              <td className="ucaltb3"></td>

              <td className="ucaltb3"></td>
            </tr>

            <tr className="uctr">
              <td className="ucaltb3" colSpan={2}>
                Gst
              </td>
              <td className="ucaltb3">{gstper}</td>
              <td className="ucaltb3">{gstper}</td>
              <td className="ucaltb3">{gstper}</td>
              <td className="ucaltb3">{gstper}</td>
              <td className="ucaltb3">{gstper}</td>
              <td className="ucaltb3" colSpan={2}>
                {gstper != "FREE"
                  ? ((foyertotal +
                      livingtotal +
                      diningtotal +
                      showerroomtotal +
                      bedroomtotal +
                      kicthentotal +
                      othertotal) *
                      gstper) /
                    100
                  : "Free"}
              </td>
            </tr>
            <tr className="uctr">
              <td className="ucaltb4" colSpan={7}>
                TOTAL AMOUNT
              </td>

              <td className="ucaltb41" colSpan={2}>
                {foyertotal +
                  livingtotal +
                  diningtotal +
                  showerroomtotal +
                  bedroomtotal +
                  kicthentotal +
                  othertotal}
                {/* {inputFields.map(bill => inputFields.total).reduce((acc, bill) => bill + acc)} */}
              </td>
            </tr>
            <tr className="uctr">
              <td className="ucaltb4" colSpan={7}>
                GRAND TOTAL AMOUNT
              </td>

              <td className="ucaltb41" colSpan={2}>
                {gstper != "FREE"
                  ? ((foyertotal +
                      livingtotal +
                      diningtotal +
                      showerroomtotal +
                      bedroomtotal +
                      kicthentotal +
                      othertotal) *
                      gstper) /
                      100 +
                    foyertotal +
                    livingtotal +
                    diningtotal +
                    showerroomtotal +
                    bedroomtotal +
                    kicthentotal +
                    othertotal
                  : foyertotal +
                    livingtotal +
                    diningtotal +
                    showerroomtotal +
                    bedroomtotal +
                    kicthentotal +
                    othertotal}
                {/* {inputFields.map(bill => inputFields.total).reduce((acc, bill) => bill + acc)} */}
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td>
                <br />
                <TextField
                  id="outlined-basic"
                  label="GST"
                  variant="outlined"
                  onChange={(e) => setgstper(e.target.value)}
                />
              </td>
              <td>
                {/* <br />
                <TextField
                  id="outlined-basic"
                  label="Disc"
                  variant="outlined"
                  value={dtxt}
                  onChange={(e) => setdtxt(e.target.value)}
                /> */}
              </td>
              <td>
                <br />
                <TextField
                  id="outlined-basic"
                  label="PDf-Name"
                  variant="outlined"
                  onChange={(e) => setpdfname(e.target.value)}
                />
              </td>
              <td>
                <br/>
              <TextField
                  id="outlined-basic"
                  label="Name For Saving"
                  variant="outlined"
                  onChange={(e) => setsaveinvoicename(e.target.value)}
                />
              </td>
              <td> </td>
              <td>
                <br />
                <Button onClick={() => exportPDF()} colSpan={2}>
                  Generate Pdf
                </Button>
                <br />
              </td>
              <td>
                <br />
                <Button onClick={() => savepdf()} colSpan={2}>
                  Save
                </Button>
                <br />
              </td>
             
            </tr>
            <tr>
            <td colSpan={7}>
                <br />
                <TextField
                  id="outlined-basic"
                  label="Disc"
                  variant="outlined"
                  className="discedit"
                  value={dtxt}
                  onChange={(e) => setdtxt(e.target.value)}
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div className="upc2">
        <div className="upc21">
          <div className="spectable">
            {" "}
            <div className="titletable"> SPECIFICATIONS</div>
            <table className="ucaltab">
              <tr className="uctr">
                <td className="ucaltb1">NO</td>
                <td className="ucaltb1">ITEM</td>
                <td className="ucaltb1">Description</td>
                <td className="ucaltb123"></td>
              </tr>
              {spectable.map((input, index) => {
                return (
                  <tr className="uctr">
                    <td className="ucaltb2">{index + 1}</td>

                    <td className="ucaltb2">{input.item}</td>
                    <td className="ucaltb2">{input.description}</td>

                    <td className="ucaltb2">
                      <Button
                        onClick={() => {
                          let data = [...spectable];
                          data.splice(index, 1);
                          setspectable(data);
                        }}
                      >
                        <BiTrashAlt />
                      </Button>
                      &nbsp;
                      <Button
                        onClick={() => {
                          if (index > 0) {
                            let data = [...spectable];
                            console.log(data);
                            console.log("data");
                            let dummy = [];
                            dummy[0] = data[index];
                            data[index] = data[index - 1];
                            data[index - 1] = dummy[0];

                            setspectable(data);
                            console.log(data);
                            notify.show(" Row Moved Up  !", "info", 2000);
                          } else {
                            alert("Not Valid ");
                          }
                        }}
                      >
                        &uarr;
                      </Button>
                      &nbsp;
                      <Button
                        onClick={() => {
                          if (index < spectable.length - 1) {
                            let data = [...spectable];
                            console.log(data);
                            console.log("data");
                            let dummy = [];
                            dummy[0] = data[index];
                            data[index] = data[index + 1];
                            data[index + 1] = dummy[0];

                            setspectable(data);
                            console.log(data);
                            notify.show(" Row Moved Down  !", "info", 2000);
                          } else {
                            alert("Not Valid !");
                          }
                        }}
                      >
                        &darr;
                      </Button>
                    </td>
                  </tr>
                );
              })}
              <tr className="uctr">
                <td className="ucaltb3"></td>
                <td className="ucaltb3"></td>
                <td className="ucaltb3"></td>
                <td className="ucaltb3"></td>
              </tr>
              <tr className="uctr">
                <td className="ucaltb3"></td>
                <td className="ucaltb3">
                  <TextField
                    id="outlined-basic"
                    label="Item"
                    variant="outlined"
                    onChange={(e) => setitem(e.target.value)}
                  />
                </td>
                <td className="ucaltb3">
                  <TextField
                    id="outlined-basic"
                    label="Description"
                    variant="outlined"
                    onChange={(e) => setitemdesc(e.target.value)}
                  />
                </td>
                <td className="ucaltb3">
                  <Button
                    onClick={() => {
                      var newfield = {
                        item: item,
                        description: itemdesc,
                      };
                      setspectable([...spectable, newfield]);
                    }}
                  >
                    Add
                  </Button>
                </td>
              </tr>
              <tr className="uctr">
                <td className="ucaltb3"></td>
                <td className="ucaltb3"></td>
                <td className="ucaltb3"></td>
                <td className="ucaltb3"></td>
              </tr>
            </table>
          </div>
        </div>
        <div className="upc22">
          <div className="spectable">
            {" "}
            <div className="titletable"> TERMS & CONDITIONS</div>
            <table className="ucaltab">
              <tr className="uctr">
                <td className="ucaltb1">NO</td>
                <td className="ucaltb1">Description</td>
                <td className="ucaltb123"></td>
              </tr>
              {termstable.map((input, index) => {
                return (
                  <tr className="uctr">
                    <td className="ucaltb2">{index + 1}</td>

                    <td className="ucaltb2">{input.description}</td>

                    <td className="ucaltb2">
                      <Button
                        onClick={() => {
                          let data = [...termstable];
                          data.splice(index, 1);
                          settermstable(data);
                        }}
                      >
                        <BiTrashAlt />
                      </Button>
                      &nbsp;
                      <Button
                        onClick={() => {
                          if (index > 0) {
                            let data = [...termstable];
                            console.log(data);
                            console.log("data");
                            let dummy = [];
                            dummy[0] = data[index];
                            data[index] = data[index - 1];
                            data[index - 1] = dummy[0];

                            settermstable(data);
                            console.log(data);
                            notify.show(" Row Moved Up  !", "info", 2000);
                          } else {
                            alert("Not Valid ");
                          }
                        }}
                      >
                        &uarr;
                      </Button>
                      &nbsp;
                      <Button
                        onClick={() => {
                          if (index < termstable.length - 1) {
                            let data = [...termstable];
                            console.log(data);
                            console.log("data");
                            let dummy = [];
                            dummy[0] = data[index];
                            data[index] = data[index + 1];
                            data[index + 1] = dummy[0];

                            settermstable(data);
                            console.log(data);
                            notify.show(" Row Moved Down  !", "info", 2000);
                          } else {
                            alert("Not Valid !");
                          }
                        }}
                      >
                        &darr;
                      </Button>
                    </td>
                  </tr>
                );
              })}
              <tr className="uctr">
                <td className="ucaltb3"></td>
                <td className="ucaltb3"></td>
                <td className="ucaltb3"></td>
                <td className="ucaltb3"></td>
              </tr>
              <tr className="uctr">
                <td className="ucaltb3"></td>

                <td className="ucaltb3">
                  <TextField
                    id="outlined-basic"
                    label="Description"
                    variant="outlined"
                    onChange={(e) => setitemdesc(e.target.value)}
                  />
                </td>
                <td className="ucaltb3">
                  <Button
                    onClick={() => {
                      var newfield = {
                        description: itemdesc,
                      };
                      settermstable([...termstable, newfield]);
                    }}
                  >
                    Add
                  </Button>
                </td>
              </tr>
              <tr className="uctr">
                <td className="ucaltb3"></td>
                <td className="ucaltb3"></td>
                <td className="ucaltb3"></td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </>
}
    </>
  );
}
